var process = require("./shim/process.js");
var currentStorage = typeof globalThis != "undefined" && globalThis.currentStorage || null;
if (!currentStorage) {
  try { currentStorage = typeof localStorage != "undefined" ? localStorage : null; } catch {}
}
if (!currentStorage) {
  currentStorage = { __FORCE_HTTPS__: "false", setItem: function (key, value) { this[key] = value; }, getItem: function (key) { return this[key]; } };
}
if (typeof globalThis != "undefined") globalThis.currentStorage = currentStorage;
if (typeof window != "undefined") {
  try {
    window.currentStorage = localStorage;
  } catch {
    window.currentStorage = {
      setItem: (p3921, p3922) => {
        currentStorage[p3921] = p3922;
      },
      getItem: p3923 => currentStorage[p3923]
    };
  }
}
const movement = require("./data/movement.js");
module.exports.gameVersion = "7.1.4";
module.exports.editorVersion = "2.0.0";
module.exports.buildVersion = "egh9QTeIptdMdJIrIKaFXvKz9fCqj0mt";
module.exports.customBuildVersion = process.env.CUSTOM_VERSION;
module.exports.isNode = typeof process != "undefined" && typeof process.release != "undefined" && process.release.name.search(/node|io.js/) !== -1;
module.exports.isProd = module.exports.isNode ? !!process.env.IS_PROD : location.host !== "127.0.0.1:8080" && location.host !== "localhost:8080" && !location.host.startsWith("192.168.") && location.host !== "localhost:18080";
module.exports.prodSchemes = ["krunker_prod", "krunker_social", "krunker_editor", "krunker_api", "krunker_matchmaker", "krunker_file_server"];
module.exports.socialBetaSchemes = ["krunker_social_beta"];
module.exports.prodURLs = ["krunker.io", "krunker.frvr.com", "krunker-production-file-server-ix7yruqzlq-uc.a.run.app"];
module.exports.socialBetaURLs = ["social_beta.krunker.io"];
if (module.exports.isNode) {
  module.exports.isProdScheme = module.exports.prodSchemes.includes(process.env.VULTR_SCHEME);
  module.exports.isSocialBeta = module.exports.socialBetaSchemes.includes(process.env.VULTR_SCHEME);
} else {
  module.exports.isProdScheme = module.exports.prodURLs.includes(location.hostname);
  module.exports.isSocialBeta = module.exports.socialBetaURLs.includes(location.hostname);
}
module.exports.alphabet = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"];
module.exports.serverSendFrequency = 10;
module.exports.serverTickFrequency = 30;
module.exports.serverSyncFrequency = 1;
module.exports.interpPDelay = 3;
module.exports.serverTickRate = 1000 / module.exports.serverTickFrequency;
module.exports.interpolation = 1.1;
module.exports.stateHistory = 500;
module.exports.dltMx = Math.round(1000 / 30);
module.exports.staticDlt = Math.round(50);
module.exports.imgSessionTime = 3600000;
module.exports.enableHttps = module.exports.isProd || !module.exports.isNode && currentStorage.__FORCE_HTTPS__ == "true";
module.exports.streamUpdate = 10000;
module.exports.maxPlayers = 8;
module.exports.serverSpread = 3;
module.exports.gamesPerServer = 2;
module.exports.gamesToCreate = 3;
module.exports.gameStartDelay = 60000;
module.exports.serverBrowserRate = 10000;
module.exports.maxPlayersTotal = module.exports.maxPlayers * module.exports.gamesPerServer + 40;
module.exports.kickTimer = 120000;
module.exports.maxPayloadLength = 750000;
const v3855 = !module.exports.isNode && (location.hostname === "127.0.0.1" || location.hostname === "localhost");
module.exports.useLooseClient = process.env.USE_LOOSE_CLIENT || v3855;
module.exports.raidsInPubs = false;
module.exports.raidMapId = 12;
module.exports.movDirs = [];
for (var vLN0569 = 0; vLN0569 < 8; ++vLN0569) {
  module.exports.movDirs.push(-Math.PI + (vLN0569 + 1) * Math.PI / 4);
}
module.exports.recaptchaKey = "6LdvBrQUAAAAAL6gtEpVNzii_3nQkbOyx912nvlm";
module.exports.hcaptchaKey = "c8058d7b-fc5a-4808-9fe7-fb6bfd45325f";
module.exports.pingCount = 10;
module.exports.maxObfPing = 100;
module.exports.maxObfPad = 55;
module.exports.minObfPad = 20;
module.exports.minKDFLvl = 50;
module.exports.minKDFCall = 15;
module.exports.kpdCallTime = 10;
module.exports.kpdDeputyMax = 10;
module.exports.kpdAutoTime = 60000;
module.exports.kpdWatchTime = 10000;
module.exports.getMaxKPDCalls = function (p3924) {
  var v3856 = p3924.jobRating;
  var v3857 = p3924.jobRatingPos;
  var v3858 = v3856 > 0 ? v3857 / v3856 : 0;
  var v3859 = p3924 && p3924.premiumT > 0 ? 2 : 1;
  if (v3856 > 100 && v3858 > 0.9) {
    return v3859 * 100;
  } else if (v3856 > 50 && v3858 > 0.9) {
    return v3859 * 50;
  } else if (v3856 > 30 && v3858 > 0.9) {
    return v3859 * 40;
  } else if (v3856 > 10 && v3858 > 0.9) {
    return v3859 * 25;
  } else {
    return v3859 * 20;
  }
};
module.exports.kpdTabs = [{
  n: "Active Calls"
}, {
  n: "Ban Logs"
}, {
  n: "Stats"
}];
if (module.exports.isProd && module.exports.isProdScheme) {
  module.exports.matchmakerURL = "https://matchmaker.krunker.io";
  module.exports.apiURL = "https://api.krunker.io";
  module.exports.socialURL = "https://social.krunker.io";
  module.exports.editorURL = "https://editor.krunker.io";
} else if (module.exports.isProd) {
  module.exports.matchmakerURL = "https://matchmaker_beta.krunker.io";
  module.exports.apiURL = "https://api_beta.krunker.io";
  module.exports.socialURL = "https://social_beta.krunker.io";
  module.exports.editorURL = "https://editor_beta.krunker.io";
} else {
  module.exports.matchmakerURL = process.env.MATCHMAKER_URI || "http://127.0.0.1:5050";
  module.exports.apiURL = process.env.API_URI || "http://127.0.0.1:5080";
  module.exports.socialURL = process.env.SOCIAL_URI || "http://127.0.0.1:5070";
  module.exports.editorURL = process.env.EDITOR_URI || "http://127.0.0.1:5090";
}
module.exports.availableRegions = module.exports.isProd ? ["de-fra", "us-ca-sv", "au-syd", "jb-hnd", "us-fl", "sgp", "us-nj", "as-mb", "us-tx", "brz", "me-bhn", "af-ct"] : ["local"];
module.exports.dedicatedOnlyRegions = ["us-wa", "us-il", "gb-lon", "mx-cmx", "as-seoul"];
module.exports.discordInvite = "https://discord.gg/W85PPvUQEr";
module.exports.partnerPReq = 100000;
module.exports.EPM = 0.8;
module.exports.gamePlBonus = [{
  val: 50000,
  bon: 20
}, {
  val: 100000,
  bon: 100
}, {
  val: 250000,
  bon: 100
}, {
  val: 500000,
  bon: 100
}, {
  val: 1000000,
  bon: 200
}];
module.exports.regionIND = {
  sgp: 2,
  "jb-hnd": 2,
  "us-nj": 4,
  "us-fl": 4,
  "us-ca-sv": 4,
  brz: 5,
  "us-tx": 4,
  "au-syd": 1,
  "de-fra": 3,
  "gb-lon": 3,
  blr: 2,
  "as-mb": 2,
  "me-bhn": 2,
  "as-seoul": 2,
  "af-ct": 3,
  "mx-cmx": 5,
  tor: 4,
  "eu-stm": 3,
  pol: 3,
  "us-hi": 4
};
module.exports.shopTabs = ["<span class='material-icons' style='color:#fbc02d;font-size:42px;vertical-align:bottom'>home</span>", "Prize Wheels", "Premium", "Purchase <span style='color:#fbc02d'>KR</span>", "Redeem Keys", "Marketplace", "<span class='material-icons' style='color:#cc51f8;font-size:42px;vertical-align:bottom'>plumbing</span>"];
module.exports.steamEnabled = true;
module.exports.steamSandbox = false;
module.exports.xsollaEnabled = true;
module.exports.xsollaSandbox = false;
module.exports.bundleLvlSort = 10;
module.exports.premiumBenifits = ["Reduced Ads", "Golden Badge on Profile", "Custom Profile Pictures", "Custom Display Name", "Increased Customization Options", "Custom Skin, Hair & Chat Colors", "Access to Spray Wheel & +1 Spray limit", "Increased Max KR per Round to 40", "Custom Commands: /god /noclip /kill /smite", "Can host 16 player lobbies", "Bigger Thumbnails for Maps", "Reduced Trade Fees & Cooldowns", "Increased Trade Limit to 20 items", "Increased Market Sale Limit to 40", "Can enter Limited Premium Areas on Custom Maps", "Increased Object Limit in Customs", "Increased Asset File Size", "Increased Asset Upload Limit"];
module.exports.currentSeason = 7;
module.exports.currentBattlepass = 2;
module.exports.easterEggs = 187;
module.exports.bpTabs = ["<span class='material-icons' style='color:#fbc02d;font-size:42px;vertical-align:bottom'>home</span>", "Challenges"];
module.exports.levelSkipPrice = "0.99";
module.exports.bppCapDay = 300;
module.exports.tradeMinLvl = 20;
module.exports.tradeCost = 10;
module.exports.tradeMaxOut = 5;
module.exports.tradeMaxOutP = 20;
module.exports.interactTradeTimer = 3000;
module.exports.rewardTime = 43200000;
module.exports.rewardMinLvl = 1;
module.exports.rewardUpdate = 1200000;
module.exports.guestMaxAdGrace = 360000;
module.exports.ftueGradualMenu = true;
module.exports.ftueBotMatches = 3;
module.exports.minChalLevel = 1;
module.exports.maxSpdRChck = 6;
module.exports.rankVar = 0.03;
module.exports.eloPer = 120;
module.exports.eloK = 32;
module.exports.minRankedLevel = 15;
module.exports.rankedCooldown = 7200000;
module.exports.rankedDeduction = 30;
module.exports.rankedClasses = [0, 1, 2, 3, 4, 5, 6, 8, 12, 13, 15];
module.exports.tmpRankTms = [{
  n: "Omen",
  w: 14930
}, {
  n: "Kanga",
  w: 7900
}, {
  n: "Lore",
  w: 6300
}, {
  n: "Oddity/Kings",
  w: 5100
}, {
  n: "KPOP",
  w: 4525
}, {
  n: "nV",
  w: 4100
}, {
  n: "Verb",
  w: 2000
}, {
  n: "Ground Zero",
  w: 1950
}, {
  n: "Bandits ESC",
  w: 1400
}, {
  n: "Arae",
  w: 1200
}, {
  n: "GLXY",
  w: 1000
}, {
  n: "NBDx",
  w: 900
}];
module.exports.endTimer = 25000;
module.exports.endAnim = 5000;
module.exports.challModeLvl = 30;
module.exports.matchPicks = 4;
module.exports.voteKickReq = 4;
module.exports.voteKickMaxLvl = 20;
module.exports.voteKickTimer = 35000;
module.exports.voteKickBan = 1800000;
module.exports.inpDirGran = 30;
module.exports.inpBackTim = 3000;
module.exports.thrdPZ = 14;
module.exports.thrdPX = 5;
module.exports.thrdPY = 2;
module.exports.publicMatchConfig = {};
module.exports.hostTypes = [{
  title: "Custom Game Setup",
  topHedr: function () {
    var vA211 = [4, 8, 9, 11, 13];
    return "<div id='hostCMapPickr' onclick='showGames(true);' style='background-image:linear-gradient(to right, #000000a8, #00000000),url(https://assets.krunker.io/img/backgrounds/gamecats/c_" + vA211[window.randInt(0, vA211.length - 1)] + ".png);'><div id='hostCMapPickT'>Browse Community Games</div><span id='hostCMapInd'>></span></div>";
  }
}, {
  title: "Comp Server Setup",
  allMaps: ["burg", "sandstorm", "undergrowth", "shipment", "industry", "lumber", "site", "bureau", "atomic"],
  topHedr: function () {
    return "<div id='hostCMapPickr' style='background-image:linear-gradient(to right, #000000a8, #00000000),url(https://assets.krunker.io/img/backgrounds/gamecats/c_1.png);'><div id='hostCMapPickT'>Dedicated comp & tournament server</div></div>";
  },
  disTabs: [1, 3],
  overDat: {
    private: true,
    allowSpect: true,
    maps: [0, 2, 4, 5, 11, 12, 14, 17, 23],
    modes: [2],
    maxPlayers: 10,
    minPlayers: 8,
    fixMov: true,
    jumpMlt: 1.005,
    slidSpd: 0.97,
    warmupTime: 0.2,
    selTeam: true,
    throwMel: false
  },
  hideHead: false,
  showAll: true,
  comp: true,
  noCustM: true
}, {
  title: "Rent Dedicated Server",
  buyServ: true,
  noCustM: true
}, {
  title: "Zombies Server Setup",
  mapH: "Zombies Maps",
  allMaps: ["facility"],
  topHedr: function () {
    return "<div id='hostCMapPickr' style='background-image:linear-gradient(to right, #000000a8, #00000000),url(https://assets.krunker.io/img/backgrounds/server_zombies.png?build=4Q9IjxljZogSd4f5mvT6QLSHsyBGeq8I);'><div id='hostCMapPickT'>Dedicated Zombies server</div></div>";
  },
  disTabs: [1, 2, 3],
  forceDat: {
    private: true,
    maxPlayers: 4,
    maps: [27],
    modes: [35],
    mimicPubs: true
  },
  allowedDat: {
    maps: [27]
  },
  noCustM: true,
  restrict: true,
  hideHead: true,
  showAll: true
}, {
  title: "Raid Server Setup",
  mapH: "Raid Maps",
  allMaps: ["tortuga", "laboratory", "soul sanctum"],
  topHedr: function () {
    return "<div id='hostCMapPickr' style='background-image:linear-gradient(to right, #000000a8, #00000000),url(https://assets.krunker.io/img/backgrounds/server_raids.png?build=4Q9IjxljZogSd4f5mvT6QLSHsyBGeq8I);'><div id='hostCMapPickT'>Dedicated Raid server</div></div>";
  },
  disTabs: [1, 2, 3],
  forceDat: {
    private: true,
    maxPlayers: 8,
    maps: [18],
    modes: [23],
    mimicPubs: true
  },
  allowedDat: {
    maps: [18, 29, 31]
  },
  noCustM: true,
  restrict: true,
  hideHead: true,
  showAll: true
}];
module.exports.serverTabs = ["Official Servers", "&nbsp;Custom Servers&nbsp;"];
module.exports.serverUpg = [{
  name: "40 Player Server",
  varN: "maxPS",
  cost: 1000
}, {
  name: "Promote Server",
  varN: "promServ",
  cost: 2500
}];
module.exports.hideLoginWindowAfterLogin = false;
module.exports.differentStorePopups = false;
module.exports.playerBlipTimer = 2000;
module.exports.hitBoxPad = 5;
module.exports.hitBoxPadP = 0.5;
const vF13 = (p3925, p3926) => ({
  name: p3925,
  varN: "classLim" + p3926,
  sub: "Class Limits",
  sub: "Other",
  basic: true,
  hostTypes: [1],
  hideE: true,
  def: 0,
  defC: module.exports.rankedClasses.includes(p3926) ? 1 : 0,
  max: 20,
  min: 0,
  step: 1,
  classIcon: p3926
});
module.exports.teamLimit = 5;
module.exports.teamNames = ["Alpha", "Bravo", "Charlie", "Delta", "Echo", "Foxtrot"];
module.exports.serverConfig = [{
  name: "Players",
  varN: "maxPlayers",
  sub: "Server Size",
  basic: true,
  def: 2,
  max: 10,
  maxP: 16,
  maxF: 20,
  maxD: 50,
  maxG: 6,
  min: 1,
  step: 1
}, {
  name: "Min Players",
  varN: "minPlayers",
  sub: "Server Size",
  basic: true,
  def: 0,
  max: 10,
  maxP: 16,
  maxF: 20,
  maxD: 50,
  maxG: 6,
  min: 0,
  step: 1
}, {
  name: "Minutes",
  varN: "gameTime",
  sub: "Timers",
  hostTypes: [0, 1],
  basic: true,
  def: 4,
  defC: 4,
  max: 60,
  min: 0,
  step: 1
}, {
  name: "Warmup",
  varN: "warmupTime",
  sub: "Timers",
  basic: true,
  def: 0,
  max: 4,
  min: 0,
  step: 0.1
}, {
  name: "Rounds",
  varN: "gamRounds",
  sub: "Timers",
  hostTypes: [0, 1],
  basic: true,
  def: 1,
  defC: 3,
  max: 10,
  min: 1,
  step: 1
}, {
  name: "Intermission (s)",
  varN: "intermTmr",
  sub: "Timers",
  hostTypes: [0, 1],
  basic: true,
  def: 30,
  defC: 30,
  max: 120,
  min: 5,
  step: 1
}, {
  name: "Auto Respawn",
  varN: "forceSpawn",
  sub: "Timers",
  dontChange: true,
  def: 0,
  max: 15,
  min: 0,
  step: 1
}, {
  name: "Lives",
  varN: "lives",
  sub: "Health & Lives",
  dontChange: true,
  basic: true,
  def: 0,
  max: 10,
  min: 0,
  step: 1
}, {
  name: "Score Limit",
  varN: "scoreLimit",
  sub: "Score & Rewards",
  def: 0,
  max: 10000,
  min: 0,
  step: 100
}, {
  name: "Keep Team Score",
  varN: "keepTScore",
  sub: "Score & Rewards",
  dontChange: true,
  def: false,
  bool: true
}, {
  name: "Objective Time",
  varN: "objtvTime",
  head: "Mode Settings",
  sub: "Mode Settings",
  hostTypes: [0, 1],
  def: 1,
  defC: 1,
  max: 10,
  min: 0.1,
  step: 0.1
}, {
  name: "Force Mode Classes",
  sub: "Mode Settings",
  varN: "forceC",
  dontChange: true,
  def: true,
  bool: true
}, {
  name: "Log Time (Race/Bhop)",
  varN: "logTim",
  sub: "Mode Settings",
  dontChange: true,
  def: true,
  bool: true
}, {
  name: "Last Checkpoint Time Rewind (Race/Bhop)",
  varN: "lstChkT",
  sub: "Mode Settings",
  dontChange: true,
  def: false,
  bool: true
}, {
  name: "Gravity",
  head: "Physics",
  sub: "World Physics",
  varN: "gravMlt",
  dontChange: true,
  def: 1,
  max: 2,
  min: 0,
  step: 0.001
}, {
  name: "Time Scale",
  varN: "deltaMlt",
  sub: "World Physics",
  dontChange: true,
  def: 1,
  max: 1.5,
  min: 0.1,
  step: 0.1
}, {
  name: "Fall Damage",
  sub: "World Physics",
  varN: "fallDmg",
  def: 0,
  max: 10,
  min: 0,
  step: 0.01
}, {
  name: "Fall Damage Thresh",
  sub: "World Physics",
  varN: "fallDmgThr",
  def: 0,
  max: 10,
  min: 0,
  step: 0.01
}, {
  name: "Jump Force",
  varN: "jumpMlt",
  sub: "Jumping",
  dontChange: true,
  def: 1,
  max: 3,
  min: 0.1,
  step: 0.001
}, {
  name: "Fixed Movement",
  varN: "fixMov",
  sub: "Movement",
  dontChange: true,
  def: false,
  bool: true
}, {
  name: "Slide Time",
  varN: "slidTime",
  sub: "Movement",
  dontChange: true,
  def: 1,
  max: 5,
  min: 1,
  step: 0.1
}, {
  name: "Slide Speed",
  varN: "slidSpd",
  sub: "Movement",
  dontChange: true,
  def: 1,
  max: 2,
  min: 0,
  step: 0.01
}, {
  name: "Weapon Impulse",
  varN: "impulseMlt",
  sub: "Gameplay Logic",
  dontChange: true,
  def: 1,
  max: 3,
  min: 0,
  step: 0.1
}, {
  name: "Wall Jump Power",
  varN: "wallJP",
  sub: "Jumping",
  dontChange: true,
  def: 1,
  max: 2,
  min: 0,
  step: 1
}, {
  name: "Strafe Speed",
  varN: "strafeSpd",
  sub: "Movement",
  dontChange: true,
  def: 1.2,
  max: 2,
  min: 1,
  step: 0.1
}, {
  name: "Sliding",
  varN: "canSlide",
  sub: "Movement",
  dontChange: true,
  def: true,
  bool: true
}, {
  name: "Air Strafe",
  varN: "airStrf",
  sub: "Movement",
  dontChange: true,
  def: false,
  bool: true
}, {
  name: "Auto Jump",
  varN: "autoJump",
  sub: "Jumping",
  dontChange: true,
  def: false,
  bool: true
}, {
  name: "Bullet Drop",
  varN: "bDrop",
  sub: "World Physics",
  dontChange: true,
  def: false,
  bool: true
}, {
  name: "Health Multiplier",
  head: "Game Logic",
  varN: "healthMlt",
  sub: "Health & Lives",
  dontChange: true,
  def: 1,
  max: 3,
  min: 0.1,
  step: 0.1
}, {
  name: "Hitbox Padding",
  varN: "hitBoxPad",
  sub: "Collisions",
  dontChange: true,
  hostTypes: [0, 1],
  def: 0.6,
  defC: 0.1,
  max: 2,
  min: -2,
  step: 0.1
}, {
  name: "Fire Rate",
  varN: "fiRat",
  sub: "Gameplay Logic",
  dontChange: true,
  def: 1,
  max: 2,
  min: 0.5,
  step: 0.1
}, {
  name: "Reload Speed",
  varN: "reSpd",
  sub: "Gameplay Logic",
  dontChange: true,
  def: 1,
  max: 2,
  min: 0.5,
  step: 0.1
}, {
  name: "Health Regen",
  varN: "hpRegen",
  sub: "Health & Lives",
  dontChange: true,
  def: true,
  bool: true
}, {
  name: "Kill Rewards",
  varN: "killRewards",
  sub: "Score & Rewards",
  dontChange: true,
  def: true,
  bool: true
}, {
  name: "No Assists",
  varN: "noAssists",
  sub: "Score & Rewards",
  dontChange: true,
  def: false,
  bool: true
}, {
  name: "Headshots Only",
  varN: "headshotOnly",
  sub: "Gameplay Logic",
  dontChange: true,
  def: false,
  bool: true
}, {
  name: "No Secondaries",
  varN: "noSecondary",
  sub: "Gameplay Logic",
  dontChange: true,
  def: false,
  bool: true
}, {
  name: "Disable Streaks",
  varN: "noStreaks",
  sub: "Other",
  dontChange: true,
  def: false,
  bool: true
}, {
  name: "Disable Borders",
  varN: "disableB",
  sub: "Other",
  dontChange: true,
  def: false,
  bool: true
}, {
  name: "Throwable Melees",
  varN: "throwMel",
  sub: "Gameplay Logic",
  dontChange: true,
  def: true,
  bool: true
}, {
  name: "Chargable Weapons",
  varN: "chrgWeps",
  sub: "Gameplay Logic",
  dontChange: true,
  def: true,
  bool: true
}, {
  name: "Select Team",
  head: "Teams",
  varN: "selTeam",
  sub: "Teams",
  dontChange: true,
  def: false,
  bool: true
}, {
  name: "Friendly Fire",
  sub: "Teams",
  varN: "frFire",
  dontChange: true,
  def: false,
  bool: true
}, {
  name: module.exports.teamNames[0] + " Team Name",
  varN: "nameTeam1",
  hostTypes: [0, 1],
  sub: "Teams",
  def: module.exports.teamNames[0],
  input: true
}, {
  name: module.exports.teamNames[1] + " Team Name",
  varN: "nameTeam2",
  hostTypes: [0, 1],
  sub: "Teams",
  def: module.exports.teamNames[1],
  input: true
}, {
  name: module.exports.teamNames[0] + " Team Damage",
  varN: "t1Dmg",
  sub: "Teams",
  dontChange: true,
  def: 1,
  max: 2,
  min: 0,
  step: 0.1
}, {
  name: module.exports.teamNames[1] + " Team Damage",
  varN: "t2Dmg",
  sub: "Teams",
  dontChange: true,
  def: 1,
  max: 2,
  min: 0,
  step: 0.1
}, {
  name: "Spectating",
  head: "Other",
  varN: "allowSpect",
  hostTypes: [0, 1],
  sub: "Other",
  def: true,
  bool: true
}, {
  name: "3rd Person",
  varN: "thirdPerson",
  sub: "Other",
  dontChange: true,
  def: false,
  bool: true
}, {
  name: "Hide Nametags (Enemies)",
  varN: "nameTags",
  sub: "Other",
  def: false,
  bool: true
}, {
  name: "Hide Nametags (Allies)",
  varN: "nameTagsFR",
  sub: "Other",
  def: false,
  bool: true
}, {
  name: "Kill Cams",
  varN: "kCams",
  sub: "Other",
  def: true,
  bool: true
}, {
  name: "Allow Anonymous",
  varN: "aAnon",
  sub: "Other",
  def: true,
  bool: true
}, {
  name: "Designated Spectators",
  varN: "specSlots",
  sub: "Other",
  basic: true,
  hostTypes: [1],
  hideE: true,
  def: 2,
  max: 4,
  min: 0,
  step: 1
}, {
  name: "Team Size",
  varN: "tmSize",
  sub: "Other",
  basic: true,
  hostTypes: [1],
  hideE: true,
  def: 3,
  options: ["1v1", "2v2", "3v3", "4v4"],
  select: true
}, {
  name: "Hide Cosmetics",
  varN: "noCosm",
  sub: "Other",
  basic: true,
  hostTypes: [1],
  hideE: true,
  def: false,
  defC: true,
  bool: true
}, {
  name: "Test Mode",
  varN: "tstCmp",
  sub: "Other",
  basic: true,
  hostTypes: [1],
  hideE: true,
  def: false,
  defC: true,
  bool: true
}, {
  name: "No Draws",
  varN: "noDraws",
  sub: "Other",
  basic: true,
  hostTypes: [1],
  hideE: true,
  def: false,
  defC: true,
  bool: true
}, {
  name: "Best of",
  varN: "bstOfR",
  sub: "Other",
  basic: true,
  hostTypes: [1],
  hideE: true,
  def: false,
  defC: true,
  bool: true
}, {
  name: "Stop Head Clipping",
  varN: "headClipFix",
  hostTypes: [0, 1],
  sub: "Other",
  def: false,
  defC: true,
  bool: true
}, {
  name: "Minimaps",
  varN: "minimaps",
  sub: "Other",
  def: true,
  bool: true
}, {
  name: "Limit Classes",
  head: "Class Limits",
  varN: "limitClasses",
  sub: "Class Limits",
  basic: true,
  hostTypes: [1],
  hideE: true,
  def: false,
  defC: true,
  bool: true
}, vF13("Triggerman", 0), vF13("Hunter", 1), vF13("Run N Gun", 2), vF13("Spray N Pray", 3), vF13("Vince", 4), vF13("Detective", 5), vF13("Marksman", 6), vF13("Rocketeer", 7), vF13("Agent", 8), vF13("Runner", 9), vF13("Deagler", 10), vF13("Bowman", 11), vF13("Commando", 12), vF13("Trooper", 13), vF13("Survivor", 14), vF13("Infiltrator", 15)];
var v3860 = module.exports.serverConfig.findIndex(p3927 => p3927.varN == "nameTeam2");
for (var vLN0569 = 3; vLN0569 < module.exports.teamLimit + 1; vLN0569++) {
  module.exports.serverConfig.splice(v3860 + (vLN0569 - 2), 0, {
    name: module.exports.teamNames[vLN0569 - 1] + " Team Name",
    varN: "nameTeam" + vLN0569,
    sub: "Teams",
    def: module.exports.teamNames[vLN0569 - 1],
    input: true,
    hide: true
  });
}
var v3861 = module.exports.serverConfig.findIndex(p3928 => p3928.varN == "t2Dmg");
for (var vLN0569 = 3; vLN0569 < module.exports.teamLimit + 1; vLN0569++) {
  module.exports.serverConfig.splice(v3861 + (vLN0569 - 2), 0, {
    name: module.exports.teamNames[vLN0569 - 1] + " Team Damage",
    varN: "t" + vLN0569 + "Dmg",
    sub: "Teams",
    dontChange: true,
    def: 1,
    max: 2,
    min: 0,
    step: 0.1,
    hide: true
  });
}
module.exports.custGUITypes = ["Box", "Text", "Image", "Div (HTML)"];
module.exports.inputTypesGUI = ["Input Value", "Player Value", "Global Value"];
module.exports.sysLibName = "GAME";
module.exports.scriptingEnabled = true;
module.exports.serverScripting = true;
module.exports.eventObjectLimit = 10;
module.exports.objectLimit = 5000;
module.exports.objectLimitF = 7500;
module.exports.objectColLimit = 4500;
module.exports.objectColLimitF = 6000;
module.exports.guiLimit = 80;
module.exports.guiLimitF = 80;
module.exports.spawnLimit = 20;
module.exports.signFontMax = 240;
module.exports.billboards = ["Random", "Krunkie Loans", "Krunker Japan", "SoonTM", "Be Like Joe", "Moomoo.io", "Report Hackers"];
module.exports.anchorLimit = 1000;
module.exports.signLimit = 100;
module.exports.lbLimit = 2;
module.exports.signTextLimit = 1500;
module.exports.signFontMin = 1;
module.exports.triggerLimit = 30;
module.exports.triggerActionLimit = 5;
module.exports.interfaceLimit = 30;
module.exports.interfaceIDMax = 2000;
module.exports.wheelLimit = 10;
module.exports.triangleLimit = 5000;
module.exports.mysteryBoxAnim = 5000;
module.exports.mysteryBoxDespawn = 15000;
module.exports.mysteryBoxDespawnTeddy = 8000;
module.exports.mysteryBoxOffset = 10;
module.exports.krumMachineAnim = 5000;
module.exports.krumMachineDespawn = 15000;
module.exports.krumMachineOffset = 10;
module.exports.zombiePerks = ["Krum", "Double-Up", "Western Hands", "Swift", "Power Slide", "Drift Fuze", "Holster"];
module.exports.maxZombiePerks = 4;
module.exports.krTriggerReq = 5259600000;
module.exports.inputTypes = ["Input Value", "Trigger Value", "Player Value", "Global Value"];
module.exports.encodingTypes = [{
  name: "Default",
  value: "LinearEncoding"
}, {
  name: "sRGBEncoding",
  value: "sRGBEncoding"
}, {
  name: "LinearEncoding",
  value: "LinearEncoding"
}];
module.exports.mappingTypes = ["UVMapping", "CubeReflectionMapping", "CubeRefractionMapping", "EquirectangularReflectionMapping", "EquirectangularRefractionMapping", "CubeUVReflectionMapping"];
module.exports.toneTypes = ["NoToneMapping", "LinearToneMapping", "ReinhardToneMapping", "CineonToneMapping", "ACESFilmicToneMapping"];
module.exports.cameraTypes = ["Spectate Camera", "Player Camera"];
module.exports.classConfig = [{
  name: "Name",
  varN: "name",
  input: true,
  len: 24
}, {
  name: "Type",
  varN: "camType",
  sub: "Camera",
  cat: 0,
  def: 0,
  options: ["FPS", "3rd Person", "Platformer (X)", "Platformer (Z)", "Orthographic"],
  select: true
}, {
  name: "X Offset",
  varN: "camOffX",
  sub: "Camera",
  cat: 0,
  def: 0,
  max: 500,
  min: 0,
  step: 1,
  decs: 0
}, {
  name: "Y Offset",
  varN: "camOffY",
  sub: "Camera",
  cat: 0,
  def: 0,
  max: 500,
  min: 0,
  step: 1,
  decs: 0
}, {
  name: "Z Offset",
  varN: "camOffZ",
  sub: "Camera",
  cat: 0,
  def: 0,
  max: 500,
  min: 0,
  step: 1,
  decs: 0
}, {
  name: "Ortho Frustum Size",
  varN: "orthoF",
  sub: "Camera",
  cat: 0,
  def: 50,
  max: 1000,
  min: 1,
  step: 1,
  decs: 0
}, {
  name: "Face Player",
  varN: "lockCamP",
  sub: "Camera",
  cat: 0,
  def: 0,
  max: 1,
  min: 0,
  step: 0.01,
  decs: 2
}, {
  name: "Lock Y Rot",
  varN: "lckCmYR",
  sub: "Camera",
  cat: 0,
  def: 0,
  max: 1,
  min: -1,
  step: 0.01,
  decs: 2
}, {
  name: "Y Limit",
  varN: "yCmLim",
  sub: "Camera",
  cat: 0,
  def: 0,
  max: 1,
  min: 0,
  step: 0.01,
  decs: 2
}, {
  name: "Mouse Rotation",
  varN: "camRot",
  sub: "Camera",
  cat: 0,
  def: true,
  bool: true
}, {
  name: "Force Pointer Lock",
  varN: "fPLock",
  sub: "Camera",
  cat: 0,
  def: false,
  bool: true
}, {
  name: "Player Type",
  varN: "mdl",
  sub: "Player Asset",
  cat: 1,
  def: 0,
  options: ["Default", "Sprite", "Model"],
  select: true
}, {
  name: "Custom Asset",
  varN: "aID",
  def: "",
  cat: 1,
  sub: "Player Asset",
  len: 12,
  input: true
}, {
  name: "Show First Person",
  varN: "mdlFP",
  sub: "Player Asset",
  cat: 1,
  def: true,
  bool: true
}, {
  name: "Asset Anim Speed",
  varN: "animS",
  sub: "Player Asset",
  max: 10,
  min: 0.1,
  step: 0.1,
  decs: 1,
  cat: 1,
  def: 1
}, {
  name: "Asset Scale",
  varN: "mdlS",
  sub: "Player Asset",
  cat: 1,
  def: 1,
  max: 100,
  min: 0.1,
  step: 0.1,
  decs: 1
}, {
  name: "Asset Preview Scale",
  varN: "mdPS",
  sub: "Player Asset",
  cat: 1,
  def: 1,
  max: 10,
  min: 0.01,
  step: 0.01,
  decs: 2
}, {
  name: "Asset Preview Y Off",
  varN: "mdPY",
  sub: "Player Asset",
  cat: 1,
  def: 0,
  max: 50,
  min: -50,
  step: 0.01,
  decs: 2
}, {
  name: "Asset Dir",
  varN: "mdlDr",
  sub: "Player Asset",
  cat: 1,
  def: 0,
  max: 360,
  min: 0,
  step: 5,
  decs: 0
}, {
  name: "Asset Y Offset",
  varN: "mdlYO",
  sub: "Player Asset",
  cat: 1,
  def: 0,
  max: 50,
  min: -50,
  step: 0.01,
  decs: 2
}, {
  name: "Move Scheme",
  varN: "movSch",
  sub: "Movement",
  cat: 1,
  def: 0,
  options: ["Default", "Follow Mouse", "Move Right", "Fly", "Dir Only", "SRM", "Vehicle", "MMORPG"],
  select: true
}, {
  name: "Speed",
  varN: "speed",
  sub: "Movement",
  cat: 1,
  max: 5,
  min: 0.01,
  step: 0.01,
  decs: 2
}, {
  name: "Speed X",
  varN: "speedX",
  sub: "Movement",
  cat: 1,
  def: 1,
  max: 50,
  min: -50,
  step: 0.1,
  decs: 1
}, {
  name: "Speed Y",
  varN: "speedY",
  sub: "Movement",
  cat: 1,
  def: 1,
  max: 50,
  min: -50,
  step: 0.1,
  decs: 1
}, {
  name: "Speed Z",
  varN: "speedZ",
  sub: "Movement",
  cat: 1,
  def: 1,
  max: 50,
  min: -50,
  step: 0.1,
  decs: 1
}, {
  name: "SpeedLines Threshold",
  varN: "spdLnTh",
  sub: "Movement",
  cat: 1,
  def: 500,
  max: 500,
  min: 1,
  step: 1,
  decs: 0
}, {
  name: "Move Dir",
  varN: "movDrP",
  sub: "Movement",
  cat: 1,
  def: 0,
  max: 1,
  min: -1,
  step: 0.1,
  decs: 1
}, {
  name: "Turn Speed",
  varN: "trnSp",
  sub: "Movement",
  cat: 1,
  def: 1,
  max: 2,
  min: 0,
  step: 0.01,
  decs: 2
}, {
  name: "Ground Accel",
  varN: "grA",
  sub: "Movement",
  cat: 1,
  def: 0.042,
  max: 0.1,
  min: 0.0001,
  step: 0.0001,
  decs: 4
}, {
  name: "Ground Decel",
  varN: "grDec",
  sub: "Movement",
  cat: 1,
  def: 0.99,
  max: 0.9999,
  min: 0.9,
  step: 0.0001,
  decs: 4
}, {
  name: "Air Accel",
  varN: "arA",
  sub: "Movement",
  cat: 1,
  def: 0.0047,
  max: 0.1,
  min: 0.0001,
  step: 0.0001,
  decs: 4
}, {
  name: "Air Decel",
  varN: "airDec",
  sub: "Movement",
  cat: 1,
  def: 0.9996,
  max: 0.9999,
  min: 0.9,
  step: 0.0001,
  decs: 4
}, {
  name: "Can Crouch",
  varN: "canCrch",
  sub: "Movement",
  def: true,
  cat: 1,
  bool: true
}, {
  name: "Crouch Speed",
  varN: "crchSpd",
  sub: "Movement",
  cat: 1,
  def: 0.3,
  max: 4,
  min: 0,
  step: 0.1,
  decs: 1
}, {
  name: "Ladder Accel",
  varN: "ldA",
  sub: "Movement",
  cat: 1,
  def: 1,
  max: 5,
  min: 0.1,
  step: 0.1,
  decs: 1
}, {
  name: "Slide Time",
  varN: "slT",
  sub: "Movement",
  cat: 1,
  max: 3,
  min: 0.01,
  step: 0.01,
  decs: 1
}, {
  name: "Slide Accel",
  varN: "slA",
  sub: "Movement",
  cat: 1,
  max: 1.5,
  min: 0.01,
  step: 0.01,
  decs: 1
}, {
  name: "Free Range Sliding",
  varN: "frSlid",
  sub: "Movement",
  def: false,
  cat: 1,
  bool: true
}, {
  name: "Backwards Sliding",
  varN: "bkSlid",
  sub: "Movement",
  cat: 1,
  bool: true
}, {
  name: "Step Frequency",
  varN: "stpFr",
  sub: "Movement",
  cat: 1,
  def: 1,
  max: 20,
  min: 0.1,
  step: 0.1,
  decs: 1
}, {
  name: "Step Sound Dynamic",
  varN: "stpSD",
  sub: "Movement",
  cat: 1,
  def: 0,
  max: 1,
  min: 0,
  step: 0.01,
  decs: 2
}, {
  name: "Health",
  varN: "health",
  sub: "Health",
  max: 5000,
  min: 1,
  step: 1,
  decs: 0
}, {
  name: "HP Segments",
  varN: "segs",
  sub: "Health",
  max: 10,
  min: 1,
  step: 1,
  decs: 0
}, {
  name: "Regen",
  varN: "regen",
  sub: "Health",
  max: 3,
  min: 0.01,
  step: 0.01,
  decs: 2
}, {
  name: "Regen Delay",
  varN: "regenDelay",
  sub: "Health",
  max: 10000,
  min: 0,
  step: 1,
  decs: 0
}, {
  name: "Hitbox Scale",
  varN: "hbS",
  sub: "Hitbox",
  cat: 1,
  def: 0,
  max: 20,
  min: 0,
  step: 0.1,
  decs: 1
}, {
  name: "Hitbox Height",
  varN: "hbH",
  sub: "Hitbox",
  cat: 1,
  def: 0,
  max: 20,
  min: 0,
  step: 0.1,
  decs: 1
}, {
  name: "Jump Cooldown",
  varN: "jpC",
  sub: "Jumping",
  cat: 1,
  def: 1,
  max: 3,
  min: 0.1,
  step: 0.1,
  decs: 1
}, {
  name: "Disable Jump",
  varN: "disJump",
  sub: "Jumping",
  cat: 1,
  def: false,
  bool: true
}, {
  name: "Infinite Jump",
  varN: "infJ",
  sub: "Jumping",
  cat: 1,
  def: false,
  bool: true
}, {
  name: "Override Jump",
  varN: "ovrJump",
  sub: "Jumping",
  cat: 1,
  def: false,
  bool: true
}, {
  name: "Can Shoot",
  varN: "canShoot",
  sub: "Shooting",
  cat: 1,
  def: true,
  bool: true
}, {
  name: "Shoot to Camera",
  varN: "shtToCam",
  sub: "Shooting",
  cat: 1,
  def: false,
  bool: true
}, {
  name: "Shot Dir Drag",
  varN: "shtDrg",
  sub: "Shooting",
  cat: 1,
  def: 1,
  max: 1,
  min: 0.01,
  step: 0.01,
  decs: 2
}, {
  name: "Shot Dir XOff",
  varN: "shotX",
  sub: "Shooting",
  cat: 1,
  def: 0,
  max: 360,
  min: 0,
  step: 5,
  decs: 0
}, {
  name: "Shot Dir YOff",
  varN: "shotY",
  sub: "Shooting",
  cat: 1,
  def: 0,
  max: 360,
  min: 0,
  step: 5,
  decs: 0
}, {
  name: "Can Hipfire",
  varN: "hipF",
  sub: "Shooting",
  def: true,
  bool: true
}, {
  name: "Crouch Shooting",
  varN: "croSh",
  sub: "Shooting",
  def: true,
  bool: true
}, {
  name: "Mid Air Shooting",
  varN: "airSh",
  sub: "Shooting",
  def: true,
  bool: true
}, {
  name: "Player Collision",
  varN: "pColl",
  sub: "Collision",
  cat: 1,
  def: false,
  bool: true
}, {
  name: "Can Melee",
  varN: "canMelee",
  sub: "Weapons",
  cat: 1,
  def: true,
  bool: true
}, {
  name: "Melee Charge Time",
  varN: "throwChrg",
  sub: "Weapons",
  cat: 1,
  max: 5000,
  min: 0,
  step: 10,
  decs: 0
}, {
  name: "Melee Rate Multiplier",
  varN: "melRate",
  sub: "Weapons",
  cat: 1,
  max: 5,
  min: 0.1,
  step: 0.1,
  decs: 1
}, {
  name: "Can Wall Jump",
  varN: "wallJ",
  sub: "Movement",
  bool: true
}, {
  name: "Walljumps Max",
  varN: "wallJM",
  sub: "Movement",
  cat: 1,
  max: 100,
  min: 0,
  step: 1,
  decs: 0
}, {
  name: "Wall Jump Decel",
  varN: "wallJD",
  sub: "Movement",
  def: 0.3,
  max: 1,
  min: 0,
  step: 0.1,
  decs: 1
}, {
  name: "Wall Jump Velocity",
  varN: "wallJV",
  sub: "Movement",
  def: 0.03,
  max: 0.1,
  min: 0.01,
  step: 0.01,
  decs: 2
}, {
  name: "Has Secondary",
  varN: "secondary",
  sub: "Weapons",
  bool: true
}, {
  name: "Custom Crosshair",
  varN: "cID",
  def: "",
  cat: 1,
  sub: "Crosshair",
  len: 12,
  input: true
}, {
  name: "Chase Crosshair",
  varN: "ccID",
  def: "",
  cat: 1,
  sub: "Crosshair",
  len: 12,
  input: true
}];
var v3862;
var v3863 = module.exports.classConfig.findIndex(p3929 => p3929.varN == "movSch") + 1;
var vLN0568 = 0;
for (var vLN0569 = 0; vLN0569 < movement.length; vLN0569++) {
  v3862 = movement[vLN0569].vals;
  if (v3862 && v3862.length) {
    var v3864;
    var v3865 = movement[vLN0569].prefix;
    for (var vLN0570 = 0; vLN0570 < v3862.length; vLN0570++) {
      v3864 = {
        ...v3862[vLN0570]
      };
      v3864.varN = v3865 + v3864.varN;
      v3864.sub = movement[vLN0569].name + " Config";
      module.exports.classConfig.splice(v3863 + vLN0568, 0, v3864);
      vLN0568++;
    }
  }
}
module.exports.effectConfig = [{
  name: "Name",
  varN: "name",
  input: true,
  len: 24
}, {
  name: "Max Limit",
  varN: "max",
  cat: 0,
  max: 10,
  min: 1,
  step: 1,
  decs: 0
}, {
  name: "Timer",
  varN: "timer",
  cat: 0,
  max: 120,
  min: 0,
  step: 1,
  decs: 0
}, {
  name: "Effect Mlt",
  varN: "mlt",
  cat: 0,
  max: 10,
  min: 0,
  step: 0.01,
  decs: 2
}, {
  name: "Health",
  varN: "hp",
  cat: 0,
  max: 100,
  min: 0,
  step: 1,
  decs: 0
}];
module.exports.playerVals = ["health", "maxHealth", "score", "classIndex"];
module.exports.custValLimit = 30;
module.exports.weaponConfig = [{
  name: "Name",
  varN: "name",
  input: true,
  len: 24
}, {
  name: "Damage",
  varN: "dmg",
  max: 200,
  min: -200,
  step: 1,
  decs: 0
}, {
  name: "Headshot Mlt",
  varN: "hsMlt",
  max: 3,
  min: 0.5,
  step: 0.0001,
  decs: 4
}, {
  name: "Legshot Mlt",
  varN: "lsMlt",
  max: 3,
  min: 0.01,
  step: 0.0001,
  decs: 4
}, {
  name: "Ammo",
  varN: "ammo",
  max: 500,
  min: 1,
  step: 1,
  decs: 0
}, {
  name: "Rate",
  varN: "rate",
  max: 1000,
  min: 70,
  step: 5,
  decs: 0
}, {
  name: "Is Burst",
  varN: "burst",
  bool: true
}, {
  name: "Burst Count",
  varN: "burstC",
  max: 10,
  min: 0,
  step: 1,
  decs: 0
}, {
  name: "Burst Rate",
  varN: "burstR",
  max: 1000,
  min: 50,
  step: 10,
  decs: 0
}, {
  name: "Reload Time",
  varN: "reload",
  max: 5000,
  min: 500,
  step: 25,
  decs: 0
}, {
  name: "Reload Y",
  varN: "reloY",
  max: 1,
  min: 0,
  step: 0.01,
  decs: 2
}, {
  name: "Swap Time",
  varN: "swapTime",
  max: 1000,
  min: 100,
  step: 10,
  decs: 0
}, {
  name: "Aim Speed",
  varN: "aimSpd",
  max: 500,
  min: 100,
  step: 10,
  decs: 0
}, {
  name: "Overcharge",
  varN: "ovrChrg",
  bool: true
}, {
  name: "Charge Time",
  varN: "chrgTime",
  max: 10000,
  min: 0,
  step: 10,
  decs: 0
}, {
  name: "Move Speed",
  varN: "spdMlt",
  max: 3,
  min: 0.5,
  step: 0.01,
  decs: 2
}, {
  name: "Pierce",
  varN: "pierce",
  max: 1,
  min: 0,
  step: 0.05,
  decs: 2
}, {
  name: "Range",
  varN: "range",
  max: 2000,
  min: 5,
  step: 1,
  decs: 0
}, {
  name: "Damage Drop",
  varN: "dmgDrop",
  max: 100,
  min: 0,
  step: 1,
  decs: 0
}, {
  name: "Move Spread",
  varN: "movSpread",
  max: 3,
  min: 0,
  step: 0.01,
  decs: 2
}, {
  name: "Ads Spread",
  varN: "adSpread",
  max: 1,
  min: 0,
  step: 0.01,
  decs: 2
}, {
  name: "Spread",
  varN: "spread",
  max: 500,
  min: 0,
  step: 0.1,
  decs: 1
}, {
  name: "Min Spread",
  varN: "minSpread",
  max: 100,
  min: 0,
  step: 0.1,
  decs: 1
}, {
  name: "Zoom",
  varN: "zoom",
  max: 15,
  min: 1,
  step: 0.01,
  decs: 2
}, {
  name: "Recoil",
  varN: "recoil",
  max: 0.05,
  min: 0,
  step: 0.0001,
  decs: 4
}, {
  name: "Recoil Y",
  varN: "recoilYM",
  max: 2,
  min: 0,
  step: 0.01,
  decs: 2
}, {
  name: "Recoil Z",
  varN: "recoilZ",
  max: 10,
  min: 0,
  step: 0.1,
  decs: 2
}, {
  name: "Recoil Z Aim",
  varN: "recoilZM",
  max: 1,
  min: -1,
  step: 0.01,
  decs: 2
}, {
  name: "Jump Power",
  varN: "jumpYM",
  max: 1,
  min: 0.1,
  step: 0.01,
  decs: 2
}, {
  name: "Impulse Range",
  varN: "physRang",
  max: 2000,
  min: 0,
  step: 1,
  decs: 0
}, {
  name: "Impulse Power",
  varN: "physPow",
  max: 2,
  min: -2,
  step: 0.001,
  decs: 3
}, {
  name: "Is Secondary",
  varN: "secondary",
  bool: true
}, {
  name: "Is Equipment",
  varN: "equipment",
  bool: true
}, {
  name: "Akimbo",
  varN: "akimbo",
  bool: true
}, {
  name: "Single Fire",
  varN: "nAuto",
  bool: true
}, {
  name: "No Spread",
  varN: "noSpread",
  bool: true
}, {
  name: "Disable ADS",
  varN: "noAim",
  bool: true
}, {
  name: "Custom Icon",
  varN: "assetIcon",
  input: true,
  len: 12
}, {
  name: "Reference Distance (Sound)",
  varN: "refDist",
  max: 5000,
  min: 0,
  step: 0.1,
  decs: 1
}, {
  name: "RollOff Factor (Sound)",
  varN: "rollOff",
  max: 1,
  min: 0,
  step: 0.01,
  decs: 2
}, {
  name: "Disable Projectile",
  varN: "pj_disable",
  bool: true
}, {
  name: "Projectile Asset",
  varN: "pj_asset",
  len: 12,
  input: true
}, {
  name: "Projectile Damage",
  varN: "pj_dmg",
  max: 200,
  min: -200,
  step: 1,
  decs: 0
}, {
  name: "Projectile Speed",
  varN: "pj_spd",
  max: 5,
  min: 0.01,
  step: 0.01,
  decs: 2
}, {
  name: "Projectile Scale",
  varN: "pj_scale",
  max: 10,
  min: 0.01,
  step: 0.01,
  decs: 2
}, {
  name: "Projectile Length",
  varN: "pj_length",
  max: 50,
  min: 1,
  step: 1,
  decs: 0
}, {
  name: "Projectile Range",
  varN: "pj_range",
  max: 10000,
  min: 10,
  step: 10,
  decs: 0
}, {
  name: "Projectile Gravity",
  varN: "pj_grav",
  max: 0.01,
  min: -0.01,
  step: 0.00001,
  decs: 5
}];
module.exports.dollarToKR = 0.00166666666;
module.exports.openseaRar = 99999;
module.exports.spinCountryBlock = ["NL", "BE"];
module.exports.recVids = ["https://www.youtube.com/embed/KU4UOD802pM", "https://www.youtube.com/embed/_2YzOlRJ1lU", "https://www.youtube.com/embed/eyotedXeW8Y", "https://www.youtube.com/embed/kuTCye_s_D4", "https://www.youtube.com/embed/tkqPBqm4JRw"];
module.exports.whoToFol = [{
  name: "Sidney",
  tag: "Developer",
  id: 201211
}, {
  name: "Vince",
  tag: "Developer",
  id: 105683
}, {
  name: "MoonJuiceAlt",
  alias: "MoonJuice",
  tag: "Streamer",
  id: 2968503
}, {
  name: "ImWaspy",
  tag: "Streamer",
  id: 2593871
}, {
  name: "cimota",
  tag: "Skin Maker",
  id: 7516049
}, {
  name: "Kilfy",
  tag: "Skin Maker",
  id: 8871318
}, {
  name: "iSpy",
  tag: "Skin Maker",
  id: 177694
}, {
  name: "Nxbulah",
  tag: "Skin Maker",
  id: 5739887
}, {
  name: "Skriller33",
  tag: "Skin Maker",
  id: 5068654
}, {
  name: "Andrii",
  tag: "Map Maker",
  id: 163429
}, {
  name: "JavieBhop",
  tag: "Map Maker",
  id: 1517556
}, {
  name: "Keybi",
  tag: "Map Maker",
  id: 310968
}, {
  name: "siktis",
  tag: "Mod Maker",
  id: 5746131
}, {
  name: "DukeV",
  tag: "Map Maker",
  id: 943615
}, {
  name: "Chwoubaka",
  tag: "Mod Maker",
  id: 4927907
}, {
  name: "Swixie",
  tag: "Streamer",
  id: 5720620
}, {
  name: "QuackyTTV",
  alias: "Quacky",
  tag: "Streamer",
  id: 3742667
}, {
  name: "Highnoon",
  tag: "Support",
  id: 361086
}, {
  name: "eskrr",
  tag: "Map Maker",
  id: 383703
}];
module.exports.minBid = 100;
module.exports.billbHours = 2;
module.exports.billbTime = module.exports.billbHours * 3600000;
module.exports.billbUpdtI = 600000;
module.exports.impresstimate = 200000;
module.exports.bidMinLvl = 20;
module.exports.bidEnabled = true;
module.exports.billSizeMlt = 0.5;
module.exports.gravity = 0.00015;
module.exports.deathY = -100;
module.exports.skyScale = 18000;
module.exports.shadowDst = 1200;
module.exports.shadowRes = 1024;
module.exports.shadowOff = 0.004;
module.exports.lightDistance = 500;
module.exports.lightIntensity = 1.3;
module.exports.ambIntensity = 1;
module.exports.cornerScl = 2.5;
module.exports.cornerH = 7;
module.exports.wallH = 5;
module.exports.wallW = 0.8;
module.exports.sunAngleX = 90;
module.exports.sunAngleY = 54;
module.exports.cornerPad = 1;
module.exports.diskSpin = 0.0002;
module.exports.ladderWidth = 3.2;
module.exports.ladderScale = 0.5;
module.exports.terrainGrid = 8;
module.exports.maxTerrainS = 4000;
module.exports.buildMax = 1200;
module.exports.otherSoundMlt = 0.55;
module.exports.networkSounds = ["spray", "taunt_0", "taunt_1", "taunt_2", "taunt_3", "weapon_1", "weapon_1_0", "weapon_2", "weapon_3", "weapon_4", "weapon_5", "weapon_6", "weapon_7", "weapon_8", "weapon_9", "weapon_10", "weapon_11", "weapon_12", "weapon_13", "weapon_14", "weapon_15", "weapon_16", "weapon_17", "weapon_18", "weapon_6_0", "weapon_1_2", "weapon_3_0", "weapon_3_2", "taunt_4", "weapon_2_0", "weapon_1_4", "weapon_1_3", "weapon_17_0", "weapon_8_0", "weapon_10_0", "collect_1", "melee_12", "headshot_0", "weapon_4_0", "melee_14", "beep_0", "bo_plant", "bo_diff", "weapon_1_5", "weapon_19", "melee_19", "jump_0", "jump_1", "step_0", "step_1", "step_2", "weapon_11_0", "weapon_4_1", "weapon_4_2", "weapon_4_3", "weapon_7_0", "melee_25", "melee_25_1", "weapon_1_6", "shoe_2", "shoe_1", "weapon_7_1", "weapon_2_1", "weapon_1_7", "weapon_2_2", "build_0", "weapon_2_3", "swing_0", "weapon_9_0", "weapon_1_8", "weapon_3_16", "weapon_14_0", "weapon_10_1", "weapon_11_1", "melee_38", "weapon_12_0", "weapon_14_1", "adrop_1", "weapon_6_1", "weapon_2_4", "weapon_10_2", "weapon_8_1", "weapon_5_0", "weapon_4_4", "cntd_1", "cntd_2", "cntd_3", "cntd_4", "cntd_5", "weapon_20", "gong_0", "dragon_0", "weapon_17_1", "weapon_3_3", "melee_42", "weapon_2_5", "dom_zone_securing_0", "dom_zone_securing_1", "dom_zone_losing_0", "dom_zone_secured_0", "dom_zone_secured_1", "dom_zone_secured_2", "dom_zone_all_0", "dom_zone_all_1", "taunt_5", "weapon_1_12", "weapon_1_9", "weapon_2_6", "weapon_2_7", "weapon_2_8", "weapon_2_9", "weapon_5_1", "weapon_5_2", "weapon_7_2", "weapon_7_3", "weapon_7_4", "weapon_7_5", "weapon_9_1", "weapon_10_3", "weapon_15_1", "weapon_15_2", "weapon_15_3", "weapon_16_1", "weapon_6_2", "weapon_3_4", "weapon_4_6", "weapon_4_5", "weapon_1_11", "weapon_17_3", "weapon_2_10", "weapon_7_6", "weapon_8_2", "weapon_11_3", "weapon_1_10", "weapon_22", "weapon_17_4", "weapon_19_0", "weapon_12_1", "weapon_14_2", "spray_1", "weapon_1_13", "weapon_2_11", "weapon_3_6", "weapon_4_8", "weapon_5_3", "weapon_6_3", "weapon_7_7", "weapon_8_3", "weapon_9_2", "weapon_10_4", "weapon_11_4", "weapon_12_2", "weapon_14_3", "weapon_15_4", "weapon_16_2", "weapon_17_4", "weapon_19_1", "weapon_3_5", "weapon_9_3", "bundle_1", "cheer_0", "bundle_2", "bundle_3", "bundle_4", "weapon_6_4", "stepwo_0", "stepwo_1", "stepwat_0", "stepwat_1", "stepsa_0", "stepsa_1", "stepsno_0", "stepsno_1", "stepsno_2", "weapon_2_13", "weapon_7_9", "melee_65", "gift_0", "weapon_28_0", "weapon_11_6", "weapon_10_6", "weapon_1_15", "weapon_1_16", "weapon_2_14", "weapon_6_6", "bundle_5", "bundle_6", "weapon_4_10", "weapon_2_15", "weapon_1_17", "weapon_23", "shoe_19", "weapon_6_7", "weapon_2_16", "weapon_21", "weapon_6_8", "weapon_6_9", "weapon_11_7", "weapon_7_10", "egg_0", "egg_1", "weapon_24", "weapon_4_11", "weapon_1_18", "weapon_25", "weapon_26", "zap_0", "weapon_5_5", "jug_0", "weapon_1_19", "weapon_27", "weapon_28", "weapon_2_17", "weapon_11_8", "weapon_6_10", "weapon_1_20", "weapon_17_6", "reload_3", "weapon_3_8", "weapon_2_18", "weapon_29", "weapon_29_blast", "weapon_4_12", "weapon_1_21", "weapon_4_13", "weapon_9_6", "weapon_16_4", "weapon_4_14", "weapon_1_22", "weapon_8_5", "bhop_reset", "weapon_4_15", "weapon_6_11", "shoe_28", "mystery_1", "mystery_0", "instantkill_0", "firesale_0", "firesale_1", "bundle_12", "bundle_13", "weapon_9_7", "weapon_upgraded", "bundle_14", "weapon_14_5", "weapon_12_4", "bundle_15", "weapon_3_9", "weapon_4_17", "weapon_5_6", "weapon_19_3", "weapon_1_23", "weapon_1_24", "weapon_4_18", "weapon_11_9", "weapon_29_2", "weapon_4_16", "weapon_2_19", "weapon_2_20", "shoe_46", "weapon_10_7", "weapon_3_10", "pick_0", "pick_1", "aim_1"];
module.exports.stepSounds = [{
  name: "Default",
  ids: ["step_0", "step_1", "step_0"]
}, {
  name: "Wood",
  ids: ["stepwo_0", "stepwo_1"]
}, {
  name: "Water",
  ids: ["stepwat_0", "stepwat_1"]
}, {
  name: "Sand",
  ids: ["stepsa_0", "stepsa_1"]
}, {
  name: "Snow",
  ids: ["stepsno_0", "stepsno_1", "stepsno_2"]
}];
module.exports.particleIDS = ["default", "grass", "fog", "ember"];
module.exports.maxParticles = 100;
module.exports.explosionRange = 200;
module.exports.particleDist = 40;
module.exports.particleBlending = ["None", "Normal", "Additive", "Subtractive", "Multiply"];
module.exports.overCharge = 1.2;
module.exports.throwCharge = 900;
module.exports.projSpreads = [0.1, -0.8, 0.3, 1, 0.1, -0.4, -0.1, 0.3, 0.5, -0.45, 0.2, -0.2];
module.exports.minDrop = 300;
module.exports.dropR = 0.1;
module.exports.chatMaxLength = 70;
module.exports.chatInterval = 800;
module.exports.voiceChatInterval = 2000;
module.exports.chatListLength = 35;
module.exports.voiceChatMaxLength = 0.65;
module.exports.voiceRate = 500;
module.exports.voiceDelay = 200;
module.exports.invisChar = "&lrm;";
module.exports.gbr = false;
module.exports.mouseSens = 0.0024;
module.exports.camChaseTrn = 0.0022;
module.exports.camChaseSpd = 0.0012;
module.exports.camChaseSen = 0.2;
module.exports.camChaseDst = 24;
module.exports.specMinD = 10;
module.exports.specMaxD = 160;
module.exports.menuCamDist = 200;
module.exports.menuCamAngle = -0.5;
module.exports.menuCamSpeed = 0.1;
module.exports.priorityPopTimer = 10000;
module.exports.clipNames = ["Idle", "Move", "MoveFast", "Jump", "Melee", "Shoot", "Crouch"];
module.exports.idleAnimS = 0.0015;
module.exports.animMult = 1.2;
module.exports.leanPull = 0.99;
module.exports.leanSens = 0.05;
module.exports.leanMax = 0.16;
module.exports.leanPullZ = 0.99;
module.exports.leanMltZ = 0.03;
module.exports.bobMltY = 0.024;
module.exports.bobPullY = 0.985;
module.exports.bobPullZ = 0.99;
module.exports.landPull = 0.994;
module.exports.landPullV = 0.985;
module.exports.bobMltZ = 0.02;
module.exports.landOff = 0.15;
module.exports.aimAnimMlt = 0.18;
module.exports.aimSlow = 0.55;
module.exports.aimJumpSlow = 0.85;
module.exports.stepAnim = 0.075;
module.exports.stepMlt = 0.25;
module.exports.stepPull = 0.995;
module.exports.collPad = 1.1;
module.exports.hpSegments = 7;
module.exports.maxHealth = 100;
module.exports.passiveInc = 500;
module.exports.cameraHeight = 1.5;
module.exports.slippingSpeed = 0.0003;
module.exports.ladderSpeed = 0.035;
module.exports.ladderDecel = 0.97;
module.exports.slideDecel = 0.999;
module.exports.slideTime = 350;
module.exports.terrainSlideDecel = 0.9996;
module.exports.groundDecel = 0.99;
module.exports.terrainDecel = 0.99;
module.exports.terrainSlipDecel = 0.99;
module.exports.playerSpeed = 0.00042;
module.exports.airSpeed = 0.000047;
module.exports.airDecel = 0.9996;
module.exports.jumpVel = 0.072;
module.exports.jumpPush = 0.1;
module.exports.decelMin = 0.0001;
module.exports.climbHeight = 3;
module.exports.cornerGlide = 4;
module.exports.wpnSpin = 0.018;
module.exports.terrainSlideThreshold = 1.9;
module.exports.terrainGravityMlt = 1.85;
module.exports.playerSlideVelMlt = 1.2;
module.exports.playerTerrainSlideVelMlt = 0.4;
module.exports.playerSlippingJumpCooldown = 500;
module.exports.materialDens = {
  flesh: 0.2,
  default: 0.5
};
module.exports.nameOffset = 0.6;
module.exports.nameOffsetHat = 0.8;
module.exports.maxNameLength = 14;
module.exports.maxPassLength = 20;
module.exports.minPassLength = 6;
module.exports.playerHeight = 11;
module.exports.chestWidth = 2.6;
module.exports.chestScale = 1.3;
module.exports.armScale = 1.2;
module.exports.legScale = 1.3;
module.exports.uArmLength = 2.7;
module.exports.armInset = -0.1;
module.exports.lArmLength = 2.7;
module.exports.headScale = 2;
module.exports.armOff = -0.8;
module.exports.legHeight = 4.2;
module.exports.playerScale = (module.exports.armScale * 2 + module.exports.chestWidth + module.exports.armInset) / 2;
module.exports.tracerMinDst = 20;
module.exports.tracerMaxDst = 500;
module.exports.tracerChance = 1;
module.exports.crouchLean = -(Math.PI * 0.1);
module.exports.crouchDst = 3;
module.exports.crouchSpd = 0.007;
module.exports.crouchJump = 0.25;
module.exports.crouchSpread = 0.55;
module.exports.crouchAnim = 0.0008;
module.exports.crouchAnimMlt = 0.5;
module.exports.spreadMove = 25;
module.exports.spreadFall = 30;
module.exports.spreadRecover = 0.985;
module.exports.spreadAdj = 0.00063;
module.exports.spreadMlt = 240;
module.exports.recoilMlt = 0.3;
module.exports.newRecoil = false;
module.exports.flagMsg = "You have the Flag";
module.exports.flagMsgE = "Enemy has your Flag";
module.exports.flagMsgRC = "Enemy has your Flag";
module.exports.flagZoneS = 24;
module.exports.flagZoneH = 36;
module.exports.flagScale = 12;
module.exports.flagOff = 6;
module.exports.flagHOff = 15;
module.exports.flagUpdate = 2500;
module.exports.flagIdle = 45000;
module.exports.interactTimer = 100;
module.exports.pickupTimer = 1000;
module.exports.pickupZoneX = 12;
module.exports.pickupZoneZ = 4;
module.exports.pickupZoneH = 2;
module.exports.pickupScale = 6;
module.exports.pickupOff = 1;
module.exports.pickupImgRange = 50;
module.exports.maxLevel = 102;
module.exports.assistTime = 5000;
module.exports.assistScore = 25;
module.exports.assistMin = 20;
module.exports.scoreStreak = 2000;
module.exports.medalAnim = 1800;
module.exports.medalDelay = 900;
module.exports.newMedals = true;
module.exports.feedTimer = 2000;
module.exports.spinTimer = 1800;
module.exports.endStats = ["sid", "name", "score", "kills", "deaths", "reward"];
module.exports.endForm = {
  reward: function (p3930) {
    if (p3930) {
      return "<span style='color:#F8C55C'>+" + p3930 + "</span> KR";
    } else {
      return "NONE";
    }
  },
  time: function (p3931, p3932, p3933) {
    return p3933.timer || "DNF";
  },
  infected: function (p3934, p3935, p3936) {
    return p3936.convs;
  },
  found: function (p3937, p3938, p3939) {
    return p3939.convs;
  },
  weapon: function (p3940, p3941, p3942) {
    return p3942.weaponTier;
  },
  objective: function (p3943, p3944, p3945) {
    return p3945.objectiveScore || 0;
  },
  confirms: function (p3946, p3947, p3948) {
    return p3948.confirms || 0;
  },
  denies: function (p3949, p3950, p3951) {
    return p3951.denies || 0;
  },
  dmg: function (p3952, p3953, p3954) {
    return Math.round(p3954.dmgDealt || 0);
  },
  zombies: function (p3955, p3956, p3957) {
    return p3957.aiKills || 0;
  },
  downs: function (p3958, p3959, p3960) {
    return p3960.deaths || 0;
  },
  points: function (p3961, p3962, p3963) {
    return p3963.score || 0;
  }
};
module.exports.hitLife = 2000;
module.exports.regenDelay = 5000;
module.exports.regenVal = 0.1;
module.exports.sprayRange = 25;
module.exports.sprayTimer = 1000;
module.exports.sprayScale = 15;
module.exports.deathDelay = 2800;
module.exports.deathFollowD = 100;
module.exports.suicides = ["uninstall life", "toaster bath", "alt f4", "not alive", "neck rope", "scooter ankle", "death.exe", "ctrl w"];
module.exports.taunts = [{
  nm: "taunt_0",
  id: 1,
  tm: 500
}, {
  nm: "taunt_1",
  id: 2,
  tm: 1000
}, {
  nm: "taunt_2",
  id: 3,
  tm: 2300
}, {
  nm: "taunt_3",
  id: 4,
  tm: 3200
}, {
  nm: "taunt_4",
  id: 28,
  tm: 3200
}, {
  nm: "taunt_5",
  id: 104,
  tm: 1000
}];
module.exports.fov = 80;
module.exports.viewDist = 2000;
module.exports.nameVisRate = 200;
module.exports.worldUV = 60;
module.exports.ambientVal = 0.5;
module.exports.ambD = 2;
module.exports.ambMlt = 15;
module.exports.ambOff = 0.09;
module.exports.ambScale = 8;
module.exports.ambDiv = 20;
module.exports.ambSFactor = 1;
module.exports.ambBleed = 0;
module.exports.boosterSpd = 0.002;
module.exports.boostRange = 100;
module.exports.minMountainMlt = 0;
module.exports.maxTerrainSize = 8000;
module.exports.minTerrainSize = 0;
module.exports.maxMountainMlt = 5;
module.exports.minZoneSize = 0;
module.exports.maxZoneSize = 10000;
module.exports.minZoneHeight = 100;
module.exports.maxZoneHeight = 10000;
module.exports.maxShrinkSpeed = 50;
module.exports.minShrinkSpeed = 1;
module.exports.maxZoneWait = 500;
module.exports.minZoneWait = 5;
module.exports.maxZoneStages = 10;
module.exports.minZoneStages = 0;
module.exports.positionRange = 500000;
module.exports.quadSize = 150;
module.exports.emitterVolMin = 0.05;
module.exports.emitterVolMax = 2;
module.exports.emitterRateMin = 0.1;
module.exports.emitterRollMin = 0;
module.exports.emitterRollMax = 1;
module.exports.emitterRateMax = 4;
module.exports.emitterDistMin = 0;
module.exports.emitterDistMax = 5000;
module.exports.emitterSounds = ["nuke_0", "siren_0", "explosion", "fart_0", "taunt_0", "taunt_1", "taunt_2", "taunt_3", "buy_0", "buy_1", "case_0", "case_1", "cheer_0", "reward", "store", "tick_0", "scare_0", "cough_1", "cough_2", "taunt_4", "ambient_1", "ambient_2", "ambient_3", "ambient_4", "ambient_5", "ambient_6", "ambient_7", "ambient_8", "beep_0", "bo_plant", "bo_diff", "collect_1", "bounce_0", "headshot_0", "hit_0", "impact_0", "jump_0", "jump_1", "land_0", "punch_0", "punch_1", "slide_0", "spray", "step_0", "step_1", "step_2", "whizz_0", "whizz_1", "gclick_0", "pick_0", "pick_1", "build_0", "break_wood", "bhop_check", "bhop_reset", "gong_0", "dragon_0", "taunt_5", "spray_1", "stepwo_0", "stepwo_1", "stepwat_0", "stepwat_1", "stepsa_0", "stepsa_1", "stepsno_0", "stepsno_1", "stepsno_2", "bounce_1", "zap_0", "jug_0", "crit_0", "melee_equip"];
module.exports.maxPfp = 250;
module.exports.aiSyncT = 5;
module.exports.airDSyncT = 5;
module.exports.leaderOSync = 5;
module.exports.aiBehavs = ["Idle", "Chase"];
module.exports.pathTypes = ["Loop", "Do Once", "Ping Pong", "Random"];
module.exports.aiLimit = 40;
module.exports.botLimit = 16;
module.exports.assetLvl = 5;
module.exports.assetCost = 0.05;
module.exports.assetCostP = 0;
module.exports.assetUploads = 400;
module.exports.assetUploadsF = 600;
module.exports.assetUploadsP = 800;
module.exports.assetUploadsPR = 1200;
module.exports.assetSize = 100;
module.exports.assetSizeP = 250;
module.exports.assetThumb = 250;
module.exports.assetThumbP = 500;
module.exports.assetIcon = 100;
module.exports.assetData = 55;
module.exports.assetTexture = 10;
module.exports.assetTextureDiffuse = 10;
module.exports.assetTextureEmissive = 10;
module.exports.assetTextureSpecular = 10;
module.exports.assetTextureNormal = 10;
module.exports.assetTextureAlpha = 10;
module.exports.assetTextureDisplacement = 10;
module.exports.assetTextureMetalness = 10;
module.exports.assetTextureRoughness = 10;
module.exports.assetTextureLight = 10;
module.exports.assetTextureBump = 10;
module.exports.assetSound = 5;
module.exports.assetVideo = 20;
module.exports.lmSize = 500;
module.exports.lmSizeP = 1000;
module.exports.assetCat = ["Clutter", "Decoration", "Trees & Vegetation", "Vehicles", "Buildings", "Furniture", "Stones & Rubble", "Technology", "Weapons", "Random & Strange", "Tools", "Food & Drink", "Characters & Creatures", "Fashion & Clothes", "Game Map", "Walls & Blocks", "Textures", "Sounds", "Triggers"];
module.exports.mapCats = ["Other", "Parkour", "Puzzle", "Trading", "Training", "Social", "Horror", "Adventure", "Battle Royale", "Realism", "Roleplay", "Rotation", "Racing", "Raid", "Remake", "NCR", "Zombies", "Simulation", "Relaxation", "Action", "Tycoon", "Mini-Games", "Single-player", "Education"];
module.exports.mapCatsP = [{
  n: "Action",
  i: 1
}, {
  n: "Parkour",
  i: 8
}, {
  n: "Remake",
  i: 4
}, {
  n: "Zombies",
  i: 7
}, {
  n: "Horror",
  i: 0
}, {
  n: "Realism",
  i: 12
}, {
  n: "Mini-Games",
  i: 5
}, {
  n: "Adventure",
  i: 2
}, {
  n: "Single-player",
  i: 10
}, {
  n: "Battle Royale",
  i: 9
}, {
  n: "Relaxation",
  i: 3
}, {
  n: "Simulation",
  i: 11
}, {
  n: "Tycoon",
  i: 6
}, {
  n: "Raid",
  i: 13
}];
module.exports.borderH = 500;
module.exports.soundScapes = {
  Default: 1,
  City: 2,
  Desert: 3,
  Market: 4,
  Scary: 5,
  Storm: 6,
  Purgatory: 7,
  "Black Market": 8,
  Tomb: 11,
  Adventure: 15,
  Sea: 16,
  Facility: 17,
  Spooky: 18,
  Festive: 19
};
module.exports.amvVols = {
  6: 0.3,
  7: 0.4,
  15: 0.04,
  16: 0.1,
  17: 0.2
};
module.exports.mapTabs = [{
  n: "Home",
  home: true,
  cache: true,
  noPages: true,
  c: 44,
  txt: "<span class='material-icons material-icons-outlined' style='color:#fbc02d;font-size:42px;vertical-align:bottom'>home</span>",
  t: "home"
}, {
  n: "Popular",
  cache: true,
  c: 44,
  t: "recent"
}, {
  n: "Featured",
  noPages: true,
  cache: true,
  c: 44,
  t: "featured"
}, {
  n: "New",
  cache: true,
  c: 44,
  t: "initialdate"
}, {
  n: "Favorites",
  c: 44,
  sendID: true,
  fav: true
}, {
  n: "My Games",
  c: 44,
  sendID: true,
  t: "votes",
  owned: true
}, {
  n: "Search",
  search: true,
  t: "votes",
  txt: "<span class='material-icons' style='color:#ffffff;font-size:42px;vertical-align:bottom'>search</span>"
}, {
  n: "Editor",
  click: "openURL(`./editor.html`)",
  txt: "<span class='material-icons' style='color:#ffffff;font-size:44px;vertical-align:bottom'>construction</span>Editor"
}, {
  n: "Sandbox",
  click: "openURL(`./?sandbox`)",
  txt: "<span class='material-icons' style='color:#ffffff;font-size:44px;vertical-align:bottom'>castle</span>Sandbox"
}, {
  n: "New & Popular",
  cache: true,
  hide: true,
  c: 80,
  t: "recent_new"
}, {
  n: "All time",
  cache: true,
  hide: true,
  c: 80,
  t: "gameplays"
}, {
  n: "Trending Now",
  cache: true,
  hide: true,
  c: 60,
  t: "plays_recent"
}, {
  n: "New & Trending",
  cache: true,
  hide: true,
  c: 80,
  t: "plays_new"
}];
module.exports.fetMapVids = {
  Atrox: "ieuJNE2lPgM",
  BattleRoyaleXXL: "1",
  Black_Tower: "AjBeYdd8tm8",
  BowsersCastle: "eWheNpYzEZ8",
  "CS1.6_dust2": "2aBrAAtlKyI",
  "CS1.6_train": "1",
  DQ_Battleboats_1: "nfcnpwCJRIs",
  FacingWorlds: "xt_5DjpwOiY",
  FallBots: "zWZ4Rn_cy0o",
  Firefly_Defense: "1",
  Firefly_Royale: "1",
  Flood_Escape: "oOnuyqoXezY",
  Gangville: "JX-Z1xdWUfc",
  JailBird: "xtA0ceyl3jo",
  LaserWar: "y-BW5MftcuY",
  Lava_Run: "P4WZhhXYI88",
  Minecraft_Ville: "195ha7DvRT8",
  Parkour_Growth: "qclcH-sIlg0",
  Pizza_place: "lZyVcTyHaoY",
  Portal_Puzzles: "199vP_Lcx0o",
  Pristis: "XdMQr0Kax88",
  STAR_WARS_versus: "1",
  Saucer_Labs: "",
  "Sky_Wars!": "raB3WyRNZXU",
  SpongeGun: "-DtGLkEwFa8",
  "TNT_Run!": "1",
  "Ten-Pin_Bowling": "1",
  TheCliff: "WGtV-4xPQ5k",
  "Walljump_6.4": "8P5ORjnUlcw",
  War_of_Krunk: "1",
  Warlord: "1",
  Zombie_Bulwark: "2XXCQo4YpSQ",
  race_AirshpPnbal: "R86AuYFTmls",
  race_Mariokart2: "vVRG5pa39GE",
  slide_daydream: "JKz4SRQaA7k",
  slide_moonlight: "UEZCekc7jjs"
};
module.exports.fetModVids = {
  RGBRave: "K4FjJRjoAUM"
};
module.exports.modSize = 25;
module.exports.modSizeP = 50;
module.exports.modTabs = [{
  n: "Home",
  home: true,
  cache: true,
  noPages: true,
  c: 44,
  txt: "<span class='material-icons-outlined' style='color:#fbc02d;font-size:42px;vertical-align:bottom'>home</span>",
  t: "featured"
}, {
  n: "Popular",
  cache: true,
  c: 44,
  t: "recent"
}, {
  n: "New",
  cache: true,
  c: 44,
  t: "initialdate"
}, {
  n: "Favorites",
  c: 44,
  sendID: true,
  fav: true
}, {
  n: "My Mods",
  c: 44,
  sendID: true,
  t: "votes",
  owned: true
}, {
  n: "Loaded",
  noLoad: true
}, {
  n: "Search",
  search: true,
  t: "votes",
  txt: "<span class='material-icons' style='color:#ffffff;font-size:42px;vertical-align:bottom'>search</span>"
}];
module.exports.businessTabs = [{
  n: "Referrals"
}, {
  n: "Contact"
}];
module.exports.partnerTabs = [{
  n: "Revenue Data"
}, {
  n: "Game Stats"
}, {
  n: "Code Sales"
}];
module.exports.mailTabs = [{
  n: "Followers"
}, {
  n: "Clan"
}, {
  n: "Hub"
}, {
  n: "Inbox"
}, {
  n: "Archive"
}];
module.exports.assetTabs = [{
  n: "New"
}, {
  n: "My Assets",
  sendUser: true
}, {
  n: "Search",
  search: true
}];
module.exports.giftMax = 10000000;
module.exports.giftMin = 10;
module.exports.giftMinLVl = 30;
module.exports.giftPMinLVl = 20;
module.exports.marketEnabled = true;
module.exports.saleMax = 10000000;
module.exports.saleGrace = 300000;
module.exports.marketMinLVl = 15;
module.exports.marketFeeBypass = 0;
module.exports.marketFee = 10 / 100;
module.exports.giftFee = 10 / 100;
module.exports.priceUpdate = 43200000;
module.exports.minQSJunk = 0.01;
module.exports.minQSKR = 5;
module.exports.streamRotation = 8000;
module.exports.creatorReset = 604800000;
module.exports.dropsEnabled = true;
module.exports.redeemDrops = true;
module.exports.dropsClientId = "hzscr5tsyjgjfl3qx9g45tcvgibrb1";
module.exports.twitchLinking = true;
module.exports.twitchUnLinking = true;
module.exports.redeemTime = 604800000;
module.exports.clanTabs = ["<span class='material-icons' style='color:#fbc02d;font-size:42px;vertical-align:bottom'>home</span>", "Members", "Stats", "Requests"];
module.exports.clanRoles = [{
  name: "Recruit"
}, {
  name: "Soldier",
  earn: true,
  max: 25
}, {
  name: "Captain",
  earn: true,
  max: 5,
  perms: 1
}, {
  name: "Commander",
  earn: true,
  max: 1,
  perms: 2
}];
module.exports.twoFAKeyLen = 6;
module.exports.maxSpraysF = 3;
module.exports.maxSpraysP = 2;
module.exports.maxSprays = 1;
module.exports.accValidationTime = 60000;
module.exports.accAnnounceId = 0;
module.exports.accAnnounce = ["Make sure to use a secure password.", "Update your password frequently and keep it in a secure place.", "Instead of using a password like pass123,", "please use something more secure like x&fyUyp92fH2sXf"];
module.exports.newDataInterval = 120000;
module.exports.ktvTimer = 120000;
module.exports.ktvMenuTimer = 300000;
module.exports.profileTabs = ["<span class='material-icons' style='color:#fbc02d;font-size:42px;vertical-align:bottom'>home</span>", "Friends", "Partner", "Settings", "Connections", "<span class='material-icons' style='color:#96ff50;font-size:42px;vertical-align:bottom'>vpn_key</span>"];
module.exports.statTabs = ["General Stats", "Killstreak Stats", "Other Stats", "Class Stats"];
module.exports.socials = ["leaders", "profile", "maps", "market", "itemsales", "clan", "map", "search", "mods", "mod", "feed", "post", "listing", "items"];
module.exports.dataDateRanges = [7, 14, 21, 30, 60, 90, 120];
module.exports.marketQueries = {
  market: {
    btn: "Info",
    checkItem: function (p3964) {
      return !!p3964.funds;
    }
  },
  inventory: {
    btn: "List to Sell",
    checkItem: function (p3965) {
      return !p3965.funds && p3965.c > 0;
    }
  },
  sales: {
    btn: "Unlist",
    checkItem: function (p3966) {
      return !!p3966.funds;
    }
  },
  stats: {},
  trades: {},
  blackm: {}
};
module.exports.leaderQueries = ["player_score", "player_kills", "player_wins", "player_timeplayed", "player_funds", "player_clan", "player_followed", "player_eventtime", "player_nukes", "player_skinvalue", "player_elo4", "player_eventcount"];
module.exports.leaderCal = {
  player_score: function (p3967) {
    var v3866 = Math.max(1, Math.floor(module.exports.rankVar * Math.sqrt(p3967)));
    return "<span class='floatR' style='color:rgba(255,255,255,0.5);'><img src='https://assets.krunker.io/img/levels/" + Math.max(Math.min(module.exports.maxLevel - 1, v3866.roundToNearest(2) - 1), 0) + ".png' class='rnkIcon'>" + v3866 + "</span>";
  },
  player_kills: function (p3968) {
    return p3968 + "<span class='lName'> kills</span>";
  },
  player_wins: function (p3969) {
    return p3969 + "<span class='lName'> wins</span>";
  },
  player_funds: function (p3970) {
    return "<span style='color:rgba(255,255,255,0.4)'>" + p3970.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + "</span> KR";
  },
  player_skinvalue: function (p3971) {
    return "<span style='color:rgba(255,255,255,0.4)'>~ " + p3971.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + "</span> KR";
  },
  player_timeplayed: function (p3972) {
    p3972 = (p3972 || 0) * 1.2;
    var v3867 = Math.floor(p3972 / 1000);
    var v3868 = Math.floor(v3867 / 60);
    v3867 %= 60;
    var v3869 = Math.floor(v3868 / 60);
    v3868 %= 60;
    var v3870 = Math.floor(v3869 / 24);
    v3869 %= 24;
    return "<span style='color:rgba(255,255,255,0.5)'>" + ((v3870 ? v3870 + "d " : "") + (v3869 ? v3869 + "h " : "") + (v3868 ? v3868 : 0) + "m " + (v3867 + "s")) + "</span>";
  },
  player_followed: function (p3973) {
    return (p3973 || 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + " <span class='lName'>followers</span>";
  },
  player_eventcount: function (p3974) {
    return "<span class='lName'>found</span> " + p3974 + "/" + module.exports.easterEggs;
  },
  player_eventtime: function (p3975) {
    return "Round " + (p3975 || 0);
  }
};
module.exports.socialRegions = ["All Regions", "Oceania", "Asia", "Europe", "North America", "South America"];
module.exports.regionNames = {
  local: "Local",
  "us-nj": "New York",
  "us-il": "Chicago",
  "us-tx": "Dallas",
  "us-wa": "Seattle",
  "us-ca-la": "Los Angeles",
  "us-ga": "Atlanta",
  "nl-ams": "Amsterdam",
  "gb-lon": "London",
  "de-fra": "Frankfurt",
  "us-ca-sv": "Silicon Valley",
  "au-syd": "Sydney",
  "fr-par": "Paris",
  "jb-hnd": "Tokyo",
  "us-fl": "Miami",
  sgp: "Singapore",
  blr: "India",
  "as-mb": "Mumbai",
  brz: "Brazil",
  "me-bhn": "Middle East",
  "af-ct": "South Africa",
  "as-seoul": "South Korea",
  "mx-cmx": "Mexico",
  "eu-stm": "Sweden",
  tor: "Toronto",
  pol: "Poland",
  "us-hi": "Hawaii"
};
module.exports.hostTransferLimit = 2;
module.exports.dediTimer = 600000;
module.exports.dediSlots = 3;
module.exports.dediDurat = [30, 60, 90];
module.exports.dediMaxPlr = 20;
module.exports.dediPrices = [7500, 14000, 20000];
module.exports.regionIndexs = ["NY", "SV", "DAL", "MIA", "STL", "CHI", "MX", "BRZ", "BHN", "TOK", "SGP", "SEO", "MBI", "FRA", "LON", "AFR", "SYD"];
module.exports.purchServRegions = [{
  r: "North America",
  n: "New York",
  f: "US"
}, {
  r: "North America",
  n: "Sillicon Valley",
  f: "US"
}, {
  r: "North America",
  n: "Dallas",
  f: "US"
}, {
  r: "North America",
  n: "Miami",
  f: "US"
}, {
  r: "North America",
  n: "Seattle",
  f: "US"
}, {
  r: "North America",
  n: "Chicago",
  f: "US"
}, {
  r: "North America",
  n: "Mexico",
  f: "MX"
}, {
  r: "South America",
  n: "Sao Paolo",
  f: "BR"
}, {
  r: "Middle East",
  n: "Manama",
  f: "BH"
}, {
  r: "East Asia",
  n: "Tokyo",
  f: "JP"
}, {
  r: "Asia",
  n: "Singapore",
  f: "SG"
}, {
  r: "East Asia",
  n: "Seoul",
  f: "KR"
}, {
  r: "South Asia",
  n: "Mumbai",
  f: "IN"
}, {
  r: "Europe",
  n: "Frankfurt",
  f: "DE"
}, {
  r: "Europe",
  n: "London",
  f: "GB"
}, {
  r: "Africa",
  n: "Cape Town",
  f: "ZA"
}, {
  r: "Australia",
  n: "Sydney",
  f: "AU"
}];
module.exports.langNames = {
  en: "English",
  es: "Español",
  de: "Deutsch",
  nl: "Nederlands",
  kr: "한국어",
  pr: "Português",
  jp: "日本語",
  fr: "Français",
  fi: "Suomi",
  zh: "简体中文",
  zhtr: "繁體中文",
  pl: "Polski",
  hi: "हिन्दी",
  ru: "Pусский",
  it: "Italiano",
  tg: "Tagalog",
  tr: "Türkçe"
};
module.exports.skinColors = [{
  id: 0,
  col: 8412234,
  name: "Bronze"
}, {
  id: 1,
  col: 10975328,
  name: "Sienna"
}, {
  id: 2,
  col: 13864303,
  name: "Rose"
}, {
  id: 3,
  col: 13408638,
  name: "Tan"
}, {
  id: 4,
  col: 15581094,
  name: "Pale"
}, {
  id: 5,
  col: 8492161,
  name: "Infected"
}];
module.exports.reportOptions = ["Hacking", "Exploiting", "Scamming", "Harassment", "Other", "Boosting", "Market Manipulation"];
module.exports.serverMessages = ["server.message.join", "server.message.left", "server.message.kicked", "server.message.banned", "server.message.votekicked", "server.message.arrested"];
module.exports.customRatios = ["Native", "800x600", "1024x768", "1280x960", "1280x1024", "1440x1080", "1656x1080"];
module.exports.unObtainCols = ["Crimson", "orange", "yellow", "lime", "MediumBlue"];
module.exports.playerCardStats = [{
  name: "SPK",
  language: "windows.loadout.other.killCardStat.spk",
  stat: function (p3976) {
    return ((p3976.account.score || 0) / Math.max(p3976.account.kills || 0, 1)).toFixed(2);
  }
}, {
  name: "Kills",
  language: "windows.loadout.other.killCardStat.kills",
  stat: function (p3977) {
    return p3977.account.kills || 0;
  }
}, {
  name: "Deaths",
  language: "windows.loadout.other.killCardStat.deaths",
  stat: function (p3978) {
    return p3978.account.deaths || 0;
  }
}, {
  name: "KDR",
  language: "windows.loadout.other.killCardStat.kdr",
  stat: function (p3979) {
    return ((p3979.account.kills || 0) / Math.max(p3979.account.deaths || 0, 1)).toFixed(2);
  }
}, {
  name: "KPG",
  language: "windows.loadout.other.killCardStat.kpg",
  stat: function (p3980) {
    return ((p3980.account.kills || 0) / Math.max(p3980.account.games || 0, 1)).toFixed(2);
  }
}, {
  name: "Games Played",
  language: "windows.loadout.other.killCardStat.gamesPlayed",
  stat: function (p3981) {
    return p3981.account.games || 0;
  }
}, {
  name: "Wins",
  language: "windows.loadout.other.killCardStat.wins",
  stat: function (p3982) {
    return p3982.account.wins || 0;
  }
}, {
  name: "W/L",
  language: "windows.loadout.other.killCardStat.wl",
  stat: function (p3983) {
    return ((p3983.account.wins || 0) / Math.max((p3983.account.games || 0) - (p3983.account.wins || 0), 1)).toFixed(2);
  }
}, {
  name: "Nukes",
  language: "windows.loadout.other.killCardStat.nukes",
  stat: function (p3984) {
    return p3984.account.stats.n || 0;
  }
}, {
  name: "Melees",
  language: "windows.loadout.other.killCardStat.melees",
  stat: function (p3985) {
    return p3985.account.stats.mk || 0;
  }
}, {
  name: "Accuracy",
  language: "windows.loadout.other.killCardStat.accuracy",
  stat: function (p3986) {
    return (p3986.account.stats.s ? Math.min(p3986.account.stats.s || 0, p3986.account.stats.h || 0) / p3986.account.stats.s * 100 : 0).round(1) + "%";
  }
}, {
  name: "KR",
  language: "windows.loadout.other.killCardStat.kr",
  stat: function (p3987) {
    return p3987.account.funds || 0;
  }
}, {
  name: "Headshots",
  language: "windows.loadout.other.killCardStat.headshots",
  stat: function (p3988) {
    return p3988.account.stats.hs || 0;
  }
}, {
  name: "Losses",
  language: "windows.loadout.other.killCardStat.losses",
  stat: function (p3989) {
    return Math.max((p3989.account.games || 0) - (p3989.account.wins || 0), 0);
  }
}, {
  name: "Wallbangs",
  language: "windows.loadout.other.killCardStat.wallbangs",
  stat: function (p3990) {
    return p3990.account.stats.wb || 0;
  }
}, {
  name: "Beatdowns",
  language: "windows.loadout.other.killCardStat.beatdowns",
  stat: function (p3991) {
    return p3991.account.stats.fk || 0;
  }
}, {
  name: "Bullseyes",
  language: "windows.loadout.other.killCardStat.bullseyes",
  stat: function (p3992) {
    return p3992.account.stats.tmk || 0;
  }
}, {
  name: "Sprays Placed",
  language: "windows.loadout.other.killCardStat.spraysPlaced",
  stat: function (p3993) {
    return p3993.account.stats.spry || 0;
  }
}, {
  name: "Assists",
  language: "windows.loadout.other.killCardStat.assists",
  stat: function (p3994) {
    return p3994.account.stats.ast || 0;
  }
}, {
  name: "Inventory Value",
  language: "windows.loadout.other.killCardStat.inventoryValue",
  stat: function (p3995) {
    return p3995.account.invVal || 0;
  }
}, {
  name: "Crouches",
  language: "windows.loadout.other.killCardStat.crouches",
  stat: function (p3996) {
    return p3996.account.stats.crc || 0;
  }
}, {
  name: "Shots",
  language: "windows.loadout.other.killCardStat.shots",
  stat: function (p3997) {
    return p3997.account.stats.s || 0;
  }
}, {
  name: "Hits",
  language: "windows.loadout.other.killCardStat.hits",
  stat: function (p3998) {
    return p3998.account.stats.h || 0;
  }
}, {
  name: "Misses",
  language: "windows.loadout.other.killCardStat.misses",
  stat: function (p3999) {
    return (p3999.account.stats.s || 0) - Math.min(p3999.account.stats.s || 0, p3999.account.stats.h || 0);
  }
}, {
  name: "Legshots",
  language: "windows.loadout.other.killCardStat.legshots",
  stat: function (p4000) {
    return p4000.account.stats.ls || 0;
  }
}, {
  name: "Slimers",
  language: "windows.loadout.other.killCardStat.slimers",
  stat: function (p4001) {
    return p4001.account.stats.sl || 0;
  }
}, {
  name: "Juggernauts",
  language: "windows.loadout.other.killCardStat.juggernauts",
  stat: function (p4002) {
    return p4002.account.stats.jg || 0;
  }
}, {
  name: "War Machines",
  language: "windows.loadout.other.killCardStat.warMachines",
  stat: function (p4003) {
    return p4003.account.stats.wm || 0;
  }
}];
module.exports.mapGenProps = {
  manager: {
    props: {
      aoOpac: {},
      objects: {
        isMapObject: true
      },
      objectives: {},
      domzones: {},
      scorezones: {},
      flags: {
        isMapObject: true
      },
      sites: {},
      pickups: {
        isMapObject: true
      },
      mysteryBoxes: {},
      perkMachines: {},
      krumMachines: {},
      gates: {
        isMapObject: true
      },
      banks: {
        isMapObject: true
      },
      pathNodes: {},
      interfaces: {},
      spinners: {
        isMapObject: true
      },
      destObjs: {},
      movedObjs: {},
      timerObjs: {},
      playerObjs: {},
      teleporters: {
        isMapObject: true
      },
      spectateCams: {
        isMapObject: true
      },
      grids: {
        isMapObject: true
      },
      envZones: {},
      pendingAIs: {},
      pendingBots: {},
      pendingLeaders: {},
      pendingTriangles: {},
      serverNodes: {
        isMapObject: true
      },
      mapAnchors: {}
    }
  },
  spawns: {},
  lastGen: {},
  terrainConfig: {
    isTerrainConfig: true
  },
  zoneConfig: {
    isZoneConfig: true
  },
  config: {},
  deathY: {}
};
module.exports.mapObjectReferenceProps = ["flagObj"];
module.exports.blankMap = JSON.stringify(require("../public/maps/subzero_new.json"));
module.exports.mobileControlPositions = {
  mobileJoystick: {
    left: 0.2,
    top: 0.69
  },
  mobileJump: {
    top: 0.5,
    right: 0.02
  },
  mobileCrouch: {
    top: 0.82,
    right: 0.15
  },
  mobileEsc: {
    left: 0.18,
    top: 0.01
  },
  mobileShoot: {
    left: 0.03,
    top: 0.28
  },
  mobileAimShoot: {
    top: 0.56,
    right: 0.13
  },
  mobileScope: {
    top: 0.35,
    right: 0.11
  },
  mobileReload: {
    top: 0.73,
    right: 0.27
  },
  mobileSwap: {
    left: 0,
    top: 0.85,
    right: 0
  },
  mobileKSwap: {
    left: 0,
    top: 0.65,
    right: 0
  }
};
module.exports.ugcTmpL = [{
  map_name: "MegaFun",
  map_description: "Challening and colorful parkour map",
  creatorname: "kokanGamingYT",
  map_pl: 0,
  map_id: 145503
}, {
  map_name: "Super_Parkour!",
  map_description: "A simple colorful parkour map",
  creatorname: "thejavi99",
  map_pl: 0,
  map_id: 111247
}, {
  map_name: "Fun_Parkour!",
  map_description: "A fun and easy parkour map for beginners",
  creatorname: "JavieBhop",
  map_pl: 0,
  map_id: 110487
}];
module.exports.cssBypass = ["DukeV", "Sidney", "Tehchy", "Vince", "0.o"];
module.exports.tutorials = [{
  name: "Editor Basics",
  code: "Ewtb2rBvg9g"
}, {
  name: "Basic Controls",
  code: "1_HixIbbCM0"
}, {
  name: "Promotion",
  code: "SxGLXklICb8"
}, {
  name: "Common Issues",
  code: "0nT8kdpAi7g"
}, {
  name: "Importing Models",
  code: "E8JWupugj4s"
}, {
  name: "Testing & Hosting",
  code: "SxM2684Us5I"
}, {
  name: "Groups & Prefabs",
  code: "qPR7EuWXM3A"
}];
module.exports.tipsAndTricks = [{
  name: "Decals",
  code: "36-oUcgoyd4"
}, {
  name: "Slippery Ice Effect",
  code: "hc4qZD0fJYk"
}, {
  name: "How to make No-Teleport (better) Ramps",
  code: "eP3Kt5HdVeo"
}, {
  name: "Fake Mirror",
  code: "yVjZGsy74Ao"
}, {
  name: "Better Glass",
  code: "EOaVlaOmgLw"
}, {
  name: "How to make Objects Fade to Black",
  code: "22945ymW_Vs"
}, {
  name: "Texture Merging",
  code: "4DuWCrdt_6Y"
}, {
  name: "Angled Rooves",
  code: "VZTtKefBk70"
}, {
  name: "No Kill (safe) Spawns",
  code: "99BNfVl8ybI"
}, {
  name: "No Glitch Ledges",
  code: "hLoeU9tcwg4"
}, {
  name: "Moving Fabric",
  code: "bk6MJiYqp28"
}, {
  name: "Fire",
  code: "xcy8rF9P2jU"
}, {
  name: "Face Rendering",
  code: "KcI12XLM73E"
}, {
  name: "Moving Water",
  code: "nMoz5AtCXkM"
}, {
  name: "Bevelled Edges",
  code: "Qr_H-f-WgJk"
}];
module.exports.twitchEvents = [{
  name: "#FORTHEKIDS Charity Event",
  charity: true,
  streamers: ["HeyImZed", "SwixieThinks", "Kaarson", "ImWaspy", "SwaggerSouls", "TobyontheTele"],
  time: {
    start: "March 6, 2021 9:00 AM UTC",
    end: "March 7, 2021 11:00 AM UTC",
    watch: "1 Hour"
  }
}, {
  name: "April Drops",
  time: {
    start: "April 9, 2021 4:00 AM UTC",
    end: "April 16, 2021 4:00 AM UTC",
    watch: "4 hours"
  }
}, {
  name: "June Drops",
  time: {
    start: "June 4, 2021 4:00 AM UTC",
    end: "June 11, 2021 4:00 AM UTC",
    watch: "4 hours"
  }
}, {
  name: "#FORTHEKIDS Charity Event",
  charity: true,
  streamers: ["HeyImZed", "SwixieThinks", "Kaarson", "ImWaspy", "UnderCoverDudes", "MoonJuice"],
  time: {
    start: "June 19, 2021 10:00 AM UTC",
    end: "June 20, 2021 10:00 AM UTC",
    watch: "3 hours"
  },
  embed: [{
    n: "HeyImZed",
    s: "June 19, 2021 10:00 AM UTC",
    e: "June 19, 2021 2:00 PM UTC"
  }, {
    n: "Kaarson",
    s: "June 19, 2021 2:00 PM UTC",
    e: "June 19, 2021 6:00 PM UTC"
  }, {
    n: "SwixieThinks",
    s: "June 19, 2021 6:00 PM UTC",
    e: "June 19, 2021 10:00 PM UTC"
  }, {
    n: "ImWaspy",
    s: "June 19, 2021 10:00 PM UTC",
    e: "June 20, 2021 2:00 AM UTC"
  }, {
    n: "MoonJuice",
    s: "June 20, 2021 2:00 AM UTC",
    e: "June 20, 2021 5:00 AM UTC"
  }, {
    n: "UnderCoverDudes",
    s: "June 20, 2021 5:00 AM UTC",
    e: "June 20, 2021 9:00 AM UTC"
  }, {
    n: "HeyImZed",
    s: "June 20, 2021 9:00 AM UTC",
    e: "June 20, 2021 10:00 AM UTC"
  }]
}, {
  name: "#FORTHEKIDS Charity Event",
  charity: true,
  streamers: ["HeyImZed", "SwixieThinks", "Kaarson", "ImWaspy", "RiotAlexis", "TheMeatMan", "gangsters_paradise"],
  time: {
    start: "October 9, 2021 6:00 AM UTC",
    end: "October 10, 2021 6:00 AM UTC",
    watch: "1.5 hours"
  },
  embed: [{
    n: "HeyImZed",
    s: "October 9, 2021 6:00 AM UTC",
    e: "October 9, 2021 9:00 AM UTC"
  }, {
    n: "TheMeatMan",
    s: "October 9, 2021 9:00 AM UTC",
    e: "October 9, 2021 1:00 PM UTC"
  }, {
    n: "RiotAlexis",
    s: "October 9, 2021 1:00 PM UTC",
    e: "October 9, 2021 4:00 PM UTC"
  }, {
    n: "Kaarson",
    s: "October 9, 2021 4:00 PM UTC",
    e: "October 9, 2021 7:00 PM UTC"
  }, {
    n: "SwixieThinks",
    s: "October 9, 2021 7:00 PM UTC",
    e: "October 9, 2021 10:00 PM UTC"
  }, {
    n: "gangsters_paradise",
    s: "October 9, 2021 10:00 PM UTC",
    e: "October 10, 2021 1:00 AM UTC"
  }, {
    n: "ImWaspy",
    s: "October 10, 2021 1:00 AM UTC",
    e: "October 10, 2021 5:00 AM UTC"
  }, {
    n: "HeyImZed",
    s: "October 10, 2021 5:00 AM UTC",
    e: "October 10, 2021 6:00 AM UTC"
  }]
}, {
  name: "Final #FORTHEKIDS Charity Event",
  charity: true,
  time: {
    start: "December 10, 2021 1:00 PM UTC",
    end: "December 17, 2021 1:00 PM UTC",
    watch: "4 hours"
  }
}, {
  name: "End of Holiday Season Drops",
  randDrop: true,
  type: "Holiday",
  rarities: [2, 3, 4],
  time: {
    start: "January 6, 2022 2:00 AM UTC",
    end: "January 13, 2022 2:00 AM UTC"
  }
}, {
  name: "Junkyard Tuesdays #1",
  titleName: true,
  desc: "Each drop has a chance to reward Crafting Materials",
  randDrop: true,
  rarities: [2, 3, 4],
  revealGrace: 14400000,
  type: "Junkyard",
  time: {
    start: "January 25, 2022 3:00 PM UTC",
    end: "January 26, 2022 3:00 PM UTC"
  }
}, {
  name: "Junkyard Tuesdays #2",
  titleName: true,
  desc: "Each drop has a chance to reward Crafting Materials",
  randDrop: true,
  rarities: [2, 3, 4],
  revealGrace: 14400000,
  type: "Junkyard",
  time: {
    start: "February 1, 2022 3:00 PM UTC",
    end: "February 2, 2022 3:00 PM UTC"
  }
}, {
  name: "Junkyard Tuesdays #3",
  titleName: true,
  desc: "Each drop has a chance to reward Crafting Materials",
  randDrop: true,
  rarities: [2, 3, 4],
  revealGrace: 14400000,
  type: "Junkyard",
  time: {
    start: "February 8, 2022 3:00 PM UTC",
    end: "February 9, 2022 3:00 PM UTC"
  }
}, {
  name: "Junkyard Tuesdays #4",
  titleName: true,
  desc: "Each drop has a chance to reward Crafting Materials",
  randDrop: true,
  rarities: [2, 3, 4],
  revealGrace: 14400000,
  type: "Junkyard",
  time: {
    start: "February 15, 2022 5:00 AM UTC",
    end: "February 16, 2022 5:00 AM UTC"
  }
}, {
  name: "Junkyard Tuesdays #5",
  titleName: true,
  desc: "Each drop has a chance to reward Crafting Materials",
  randDrop: true,
  rarities: [2, 3, 4],
  revealGrace: 14400000,
  type: "Junkyard",
  time: {
    start: "February 22, 2022 5:00 AM UTC",
    end: "February 23, 2022 5:00 AM UTC"
  }
}, {
  name: "Junkyard Tuesdays #6",
  titleName: true,
  desc: "Each drop has a chance to reward Crafting Materials",
  randDrop: true,
  rarities: [2, 3, 4],
  revealGrace: 14400000,
  type: "Junkyard",
  time: {
    start: "March 1, 2022 5:00 AM UTC",
    end: "March 2, 2022 5:00 AM UTC"
  }
}, {
  name: "Junkyard Tuesdays #7",
  titleName: true,
  desc: "Each drop has a chance to reward Crafting Materials",
  randDrop: true,
  rarities: [2, 3, 4],
  revealGrace: 14400000,
  type: "Junkyard",
  time: {
    start: "March 8, 2022 5:00 AM UTC",
    end: "March 9, 2022 5:00 AM UTC"
  }
}, {
  name: "Junkyard Tuesdays #8",
  titleName: true,
  desc: "Each drop has a chance to reward Crafting Materials",
  randDrop: true,
  rarities: [2, 3, 4],
  revealGrace: 14400000,
  type: "Junkyard",
  time: {
    start: "March 15, 2022 5:00 AM UTC",
    end: "March 16, 2022 5:00 AM UTC"
  }
}, {
  name: "Junkyard Tuesdays #9",
  titleName: true,
  desc: "Each drop has a chance to reward Crafting Materials",
  randDrop: true,
  rarities: [2, 3, 4],
  revealGrace: 14400000,
  type: "Junkyard",
  time: {
    start: "March 22, 2022 5:00 AM UTC",
    end: "March 23, 2022 5:00 AM UTC"
  }
}, {
  name: "Junkyard Tuesdays #10",
  titleName: true,
  desc: "Each drop has a chance to reward Crafting Materials",
  randDrop: true,
  rarities: [2, 3, 4],
  revealGrace: 14400000,
  type: "Junkyard",
  time: {
    start: "March 29, 2022 5:00 AM UTC",
    end: "March 30, 2022 5:00 AM UTC"
  }
}, {
  name: "Junkyard Tuesdays #11",
  titleName: true,
  desc: "Each drop has a chance to reward Crafting Materials",
  randDrop: true,
  rarities: [2, 3, 4],
  revealGrace: 14400000,
  type: "Junkyard",
  time: {
    start: "April 5, 2022 5:00 AM UTC",
    end: "April 6, 2022 5:00 AM UTC"
  }
}, {
  name: "Junkyard Tuesdays #12",
  titleName: true,
  desc: "Each drop has a chance to reward Crafting Materials",
  randDrop: true,
  rarities: [2, 3, 4],
  revealGrace: 14400000,
  type: "Junkyard",
  time: {
    start: "April 12, 2022 5:00 AM UTC",
    end: "April 13, 2022 5:00 AM UTC"
  }
}, {
  name: "Junkyard Tuesdays #13",
  titleName: true,
  desc: "Each drop has a chance to reward Crafting Materials",
  randDrop: true,
  rarities: [2, 3, 4],
  revealGrace: 14400000,
  type: "Junkyard",
  time: {
    start: "April 19, 2022 5:00 AM UTC",
    end: "April 20, 2022 5:00 AM UTC"
  }
}, {
  name: "Junkyard Tuesdays #14",
  titleName: true,
  desc: "Each drop has a chance to reward Crafting Materials",
  randDrop: true,
  rarities: [2, 3, 4],
  revealGrace: 14400000,
  type: "Junkyard",
  time: {
    start: "April 26, 2022 5:00 AM UTC",
    end: "April 27, 2022 5:00 AM UTC"
  }
}, {
  name: "Krunker x FRVR",
  titleName: true,
  desc: "Celebrating the Krunker x FRVR announcement",
  revealGrace: 172800000,
  time: {
    start: "May 11, 2022 10:00 AM UTC",
    end: "May 16, 2022 10:00 AM UTC",
    watch: "2.5 hours"
  }
}, {
  name: "Season 7 Launch",
  titleName: true,
  desc: "Celebrating the launch of Season 7",
  revealGrace: 172800000,
  time: {
    start: "April 4, 2023 12:00 PM UTC",
    end: "April 11, 2023 12:00 PM UTC",
    watch: "4 hours"
  }
}];
module.exports.updateBgs = [{
  id: 0,
  creator: "@EmpoTheDon",
  link: "https://twitter.com/EmpoTheDon"
}, {
  id: 1,
  creator: "@EmpoTheDon",
  link: "https://twitter.com/EmpoTheDon"
}, {
  id: 2,
  name: "Kids",
  creator: "@14julink",
  link: "https://twitter.com/14julink"
}, {
  id: 3,
  name: "Sun gazzing",
  creator: "@14julink",
  link: "https://twitter.com/14julink"
}, {
  id: 4,
  name: "Shrine",
  creator: "@14julink",
  link: "https://twitter.com/14julink"
}, {
  id: 8,
  name: "Officer",
  creator: "@Flair741",
  link: "https://twitter.com/Flair741"
}, {
  id: 9,
  name: "Samurai",
  creator: "@polluxvisuals",
  link: "https://twitter.com/polluxvisuals"
}];
module.exports.themes = ["Default", "NASA"];
module.exports.events = [];